import React, { Fragment } from 'react';
import classNames from 'classnames';
import Slide from './Slide';
import Layout from './Layout';
import Overlay from './Overlay';
import HorizontalScroll from './HorizontalScroll';
import SlideHeading from './SlideHeading';
import Quote from './Quote';
import ProjectTitle  from './Project_Title';
import ProjectCredits from './Project_Credits';
import VideoLink from './Video';
import VideoFrame from './VideoFrame';
import HotspotImage from './HotspotImage';

import slideStyles from './css-modules/slide.module.css';
import layoutStyles from './css-modules/Layout.module.css';
import imageStyles from './css-modules/image_styles.module.css';
import overlay_styles from './css-modules/overlay.module.css';

import Slide1Back from '../resources/backgrounds/Chapter 1 Slide 1.jpg';
import Slide2Back from '../resources/backgrounds/Chapter 1 Slide 2.jpg';
import Slide3Back from '../resources/backgrounds/Chapter 1 Slide 3.jpg';
import Slide4Back from '../resources/backgrounds/Chapter 2 Slide 1.jpg';
import Slide5Back from '../resources/backgrounds/Chapter 2 Slide 2.jpg';
import Slide6Back from '../resources/backgrounds/Chapter 2 Slide 1.jpg';
import Slide7Back from '../resources/backgrounds/Chapter 3 Slide 1.jpg';
import Slide8Back from '../resources/backgrounds/Chapter 3 Slide 2.jpg';
import Slide9Back from '../resources/backgrounds/Chapter 4 Slide 1.jpg';
import Slide10Back from '../resources/backgrounds/Chapter 4 Slide 2.jpg';
import Slide11Back from '../resources/backgrounds/Chapter 4 Slide 3.jpg';

import maulanaAzad1 from '../resources/media/ch1/maulanaAzad.png';
import GCSketch from '../resources/media/ch1/GCSketch.png';
import Leitner from '../resources/media/ch1/Leitner.png';
import AabeHayat from '../resources/media/ch1/Aab e hayat.png';
import AabeHayatJPG from '../resources/media/ch1/Aab e hayat.jpg';
import MaulanaAzad2 from '../resources/media/ch1/MaulanaAzad2.jpg';
import dardistan from '../resources/media/ch1/Dardistan.jpg';
import Hali from '../resources/media/ch1/AltafHussainhali.jpg';
import Mall from '../resources/media/ch1/The Mall c. 1950s.jpg';
import Anarkali from '../resources/media/ch1/Anarkali bazaar 1947.jpg';
import Bhaati from '../resources/media/ch1/Bhatti gate.jpg';
import GC from '../resources/media/ch1/Governmnet college 1950s.jpg';
import PTHMap from '../resources/media/ch1/PTH_map.jpg';
import PakT1 from '../resources/media/ch1/PAKT1_DAWN.jpg';
import PakT2 from '../resources/media/ch1/PAKT2_DAWN.jpg';
import PakT3 from '../resources/media/ch1/PAKT3_DAWN.jpg';
import PakT4 from '../resources/media/ch1/PAKT4_DAWN.jpg';

import FaizSajjad from '../resources/media/ch2/Faiz_Sajjad2_Flickr.png';
import PWALogo from '../resources/media/ch2/PWA_logo.png';
import AngarayTitle from '../resources/media/ch2/angaaray original.jpg';
import AngarayTeam from '../resources/media/ch2/PWA_Angaare.jpg';
import AngarayUrdu from '../resources/media/ch2/Angaare_Urdu.png';
import AngarayEng from '../resources/media/ch2/Angaare_Eng.png';
import SajjadZah from '../resources/media/ch2/SajjadZaheer.jpg';
import PWAPolitics from '../resources/media/ch2/PWAPolitics.jpg';
import PWA_Politics from '../resources/media/ch2/PWA_Politics.jpg';
import PWA_MaulviAH from '../resources/media/ch2/PWA_MaulviAH1.jpg';
import SajjadZaheerGall from '../resources/media/ch2/SajjadZaheerRadio.jpg';
import FaizStamp from '../resources/media/ch2/FaizStamp.png';
import HasanAskari from '../resources/media/ch2/Hasan Askari.jpg';
import SibteHasan from '../resources/media/ch2/sibte.jpg';
import AbdulMalik from '../resources/media/ch2/AbdullahMalik.jpg';
import AM_Faiz from '../resources/media/ch2/PWAGallery/AM_Faiz.jpg';
import AM_SZ from '../resources/media/ch2/PWAGallery/AM_SZ.jpg';
import Faiz_AM from '../resources/media/ch2/PWAGallery/Faiz_AM.jpg';
import Faiz_SH from '../resources/media/ch2/PWAGallery/Faiz_SH.jpg';
import Faiz_SZ from '../resources/media/ch2/PWAGallery/Faiz_SZ.jpg';
import SH_Ismet from '../resources/media/ch2/PWAGallery/SH_Ismet.jpg';
import FaizLetter1 from '../resources/media/ch2/PWAGallery/Faiz1.jpg';
import FaizLetter2 from '../resources/media/ch2/PWAGallery/Faiz2.jpg';
import FaizLetter3 from '../resources/media/ch2/PWAGallery/Faiz3.jpg';
import SHLetter1 from '../resources/media/ch2/PWAGallery/SibteHasan.jpg';
import Roshnai from '../resources/media/ch2/PWAGallery/Roshnai.jpg';
import MusaMarx from '../resources/media/ch2/PWAGallery/MusaMarx.jpg';
import Manto from '../resources/media/ch2/Manto.jpg';

import HAZLogo1 from '../resources/media/ch3/HAZ_logo11.png';
import HAZLogo2 from '../resources/media/ch3/HAZ_logo2.jpg';
import HalqaBook from '../resources/media/ch3/ArbabeZouq.jpg';
import QayyumNazar from '../resources/media/ch3/Qayyum_Nazar.jpg';
import IntizarHussain from '../resources/media/ch3/Intizar-Hussain.jpg';
import Miraji from '../resources/media/ch3/Miraji.jpg';
import YusufZafar from '../resources/media/ch3/Shahsawar-YusufZafar.jpg';
import Taabish from '../resources/media/ch3/Taabish.jpg';
import SherMA from '../resources/media/ch3/SherMA.jpg';
import HN1 from '../resources/media/ch3/HalqaNotes/HN1.jpg';
import HN2 from '../resources/media/ch3/HalqaNotes/HN2.jpg';
import HN3 from '../resources/media/ch3/HalqaNotes/HN3.jpg';
import HN4 from '../resources/media/ch3/HalqaNotes/HN4.jpg';
import HN5 from '../resources/media/ch3/HalqaNotes/HN5.jpg';

import MeerajiTitle from '../resources/media/ch4/Meeraji1.png';
import MeerajiPort from '../resources/media/ch4/Miraji.jpg';
import MeerajiVideo from '../resources/media/ch4/MirajiPort.jpg';
import MeerajiNazm from '../resources/media/ch4/Meeraji_Nazm.jpg';
import MeerajiNazmein from '../resources/media/ch4/MeerajiNazmein.jpg';
import Chirag_Miraji from '../resources/media/ch4/Chirag_Miraji.jpg';
import MirajiDeath from '../resources/media/ch4/Miraji death news.jpg';
import MeerajiGeet from '../resources/media/ch4/miraji-geet.jpg';
import MeerajiGeeta from '../resources/media/ch4/Miraji-book-geeta.jpg';
import MeerajiPoem from '../resources/media/ch4/Meeraji_Poem.jpg';

import { MdChevronRight } from "react-icons/md";
import { MdChevronLeft } from "react-icons/md";

import ChapterTitle from './Chapter_Title';
import chapter_title_styles from './css-modules/chapter_title.module.css';
import Chapter1Title from '../resources/backgrounds/Chapter 1 Title.jpg';
import Chapter2Title from '../resources/backgrounds/Chapter 2 Title.jpg';
import Chapter3Title from '../resources/backgrounds/Chapter 3 Title.jpg';
import Chapter4Title from '../resources/backgrounds/MerajiBG.jpg';
import ProjectTitleBack from '../resources/backgrounds/Main Title.jpg';
import ProjectCreditsBack from '../resources/backgrounds/LitCredits.jpg';

import chTStyles from './css-modules/chTitle.module.css';


//Import Mobile Components

import MobileSlide from './MobileSlide';
import ProjectTitleMobile from './mobile-components/Project_Title_Mob';
import ChapterTitleMobile from './mobile-components/Chapter_Title_Mob';
import MobileSectionTitle from './mobile-components/MobileSectionTitle';
import mobileStyles from './css-modules/mobileStyles.module.css';
import NextChapterTitle from './mobile-components/NextChapterTitle';
import ProjectCreditsMobile from './mobile-components/Project_Credits_Mob';

//Mobile Imports Above

// mobile specific images

import ch1Dark from '../resources/backgrounds/mobile/Ch1-dark.jpg';
import ch1Light from '../resources/backgrounds/mobile/Ch1-light.jpg';
import ch2Dark from '../resources/backgrounds/mobile/Ch2-dark.jpg';
import ch2Light from '../resources/backgrounds/mobile/Ch2-light.jpg';
import ch3Dark from '../resources/backgrounds/mobile/Ch3-dark.jpg';
import ch3Light from '../resources/backgrounds/mobile/Ch3-light.jpg';
import ch4Dark from '../resources/backgrounds/mobile/Ch4-dark.jpg';
import ch4Light from '../resources/backgrounds/mobile/Ch4-light.jpg';

const imageArr =
[
  Slide1Back,
  Slide2Back,
  Slide3Back,
  Slide4Back,
  Slide5Back,
  Slide6Back,
  Slide7Back,
  Slide8Back,
  Slide9Back,
  Slide10Back,
  Slide11Back,
  maulanaAzad1,
  GCSketch ,
  Leitner,
  AabeHayat,
  AabeHayatJPG,
  MaulanaAzad2,
  dardistan,
  Hali,
  Mall,
  Anarkali ,
  Bhaati,
  GC,
  PTHMap,
  PakT1,
  PakT2,
  PakT3,
  PakT4,
  FaizSajjad,
  PWALogo,
  AngarayTitle,
  AngarayTeam,
  AngarayUrdu,
  AngarayEng,
  SajjadZah,
  PWAPolitics,
  PWA_Politics,
  PWA_MaulviAH,
  SajjadZaheerGall,
  FaizStamp,
  HasanAskari,
  SibteHasan,
  AbdulMalik,
  AM_Faiz,
  AM_SZ,
  Faiz_AM,
  Faiz_SH,
  Faiz_SZ,
  SH_Ismet,
  FaizLetter1,
  FaizLetter2,
  FaizLetter3,
  SHLetter1,
  Roshnai,
  MusaMarx,
  Manto,
  HAZLogo1,
  HAZLogo2,
  HalqaBook,
  QayyumNazar,
  IntizarHussain,
  Miraji,
  YusufZafar,
  HN1,
  HN2,
  HN3,
  HN4,
  HN5,
  MeerajiTitle,
  MeerajiPort,
  MeerajiVideo,
  MeerajiNazm,
  MeerajiNazmein,
  Chirag_Miraji,
  MirajiDeath,
  MeerajiGeet,
  MeerajiGeeta,
  MeerajiPoem,
  ChapterTitle,
  chapter_title_styles,
  Chapter1Title,
  Chapter2Title,
  Chapter3Title,
  Chapter4Title,
  ProjectTitleBack,
  ProjectCreditsBack
];

const slideMap = {
  "home" : {
    name : "Lahore’s Literary Landscape",
    slides : {
      "home" : {
        component : (
          <Slide bgImage={ProjectTitleBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                  <div className={slideStyles.slideContent}>
                    <ProjectTitle
                      title="Lahore’s Literary Landscape"
                      description="Exploring places, personalities and movements that shaped the literary culture of Lahore between the 1930s and 1970s"
                    />
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter1",
        next : "chapter1",
        menuInverted : false,
        hideChapterNumber: true,
        hideVerticalNav: true,
      },
    }
  },
  "chapter1" : {
    name : "Chapter 1: Lahore - a literary center",
    slides : {
      "chapter1" : {
        component : (
          <Slide bgImage={Chapter1Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                      <ChapterTitle
                        inverted
                        addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                        chapter_number="1"
                        chapter_title="Lahore - a literary center"
                        subtitle = "لاہور، ایک ادبی مرکز"
                        urduSub
                        images={[
                          {image: maulanaAzad1, id: chTStyles.maulanaAzad1, shift : 15},
                          {image: GCSketch, id: chTStyles.GCSketch, shift : -10},
                          {image: Leitner, id: chTStyles.Leitner, shift : 10},
                          {image: AabeHayat, id: chTStyles.AabeHayat, shift : -6}
                        ]}
                      />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "home",
        next : "chapter1slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter1slide1" : {
        slideName : "Origins of Urdu in Lahore",
        component : (
          <Slide bgImage={Slide1Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading title="Origins of Urdu in Lahore" subtitle= "19th Century" desc=""/>
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div>
                              <p className={slideStyles.slidePara}>
                                After annexing Punjab in the late 19th century, the British changed the official language of Punjab from Persian to Urdu. Punjabi - the most widely spoken language was not even considered as an option as it was described in derogatory terms in colonial documents as “rural patois”, a dialect not adequate to be set as the official language.
                              </p>
                              <p className={slideStyles.slidePara}>
                                To institute the teaching of Urdu in Punjab, the British encouraged a number of luminaries to migrate from North India to take up employment in Lahore. Muhammad Husain Azad migrated to Lahore in 1861 and joined the recently established Government College. He later joined the <i>Anjuman-i-Punjab</i>, started by Gottlieb W. Leitner, to promote Urdu literary practices.
                              </p>
                              <p className={slideStyles.slidePara}>
                                These two factors made Lahore an important center of Urdu literary culture. <i>Mushairas</i> were held regularly by the <i>Anjuman-e-Punjab</i> on the suggestion of Leitner. The emphasis was put on reforming Urdu poetry to adopt a more modern sensibility. The poets who came to Lahore, like Hali, were encouraged to ‘reform’ Urdu poetry by composing verses in the <i>nazam</i> format, as opposed to the <i>ghazal</i>.
                              </p>
                            </div>
                          </div>
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div id={imageStyles.lit18_Gallery_1} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                              <img src={MaulanaAzad2} className={classNames(imageStyles.hover_effect)} alt="Shams-ul-Ulema, Maulana Muhammad Husain Azad was a pioneer of Urdu literature in Lahore" style = {{'width': '100%'}}/>
                            </div>
                          </div>
                        </Layout>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.lit18_Gallery_2} className={classNames(imageStyles.Lit_gallery, slideStyles.imgBorder, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="1880. Mohammad Husain Azad’s seminal work, Aab-e-Hayat (water of life) on the history of Urdu language published. Azad was a part of the Urdu writers who migrated from Delhi to Lahore after the War of 1857 and initiated the beginnings of an Urdu literary culture of Lahore." className={classNames(imageStyles.hover_effect)} src={AabeHayatJPG}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <div id={imageStyles.lit18_Gallery_3} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="A linguist and educator, Gottlieb W. Leitner was appointed the Principal of Government College Lahore in 1864. While at Government College. Leitner set up the Anjuman-i-Ishaat-i-Mutalib-i-Mufida-i-Punjab, ‘The society for the diffusion of useful knowledge’, whose prime objective was the diffusion of literary and scientific knowledge in vernacular languages. The photo shows the title page of Leitner's book 'The Languages and races of Dardistan'. Dardistan was a term coined by Leitner for Northern Indian regions including Kashmir" className={classNames(imageStyles.hover_effect)} src={dardistan}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.lit18_Gallery_4} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="The Urdu poet Maulana Altaf Hussain Hali migrated to Lahore in 1869 to work at the Government Book Depot and stayed till 1874. He used to partake in the mushairas organized by the Anjuman-i-Punjab" className={classNames(imageStyles.hover_effect)} src={Hali}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p><i>Shams-ul-Ulema</i> Maulana Muhammad Husain Azad was a pioneer of Urdu literature in Lahore</p>,
                        source : "Flickr",

                        render : ()=> <img alt="" src={MaulanaAzad2} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '65%', marginLeft: '17.5%'}}></img>,
                      },
                      {
                        description : <p>Mohammad Husain Azad’s seminal work, <i>Aab-e-Hayat</i> (water of life), on the history of Urdu language published in 1880. Azad was an important literary figure who migrated from Delhi to Lahore after the War of 1857 and initiated the beginnings of an Urdu literary culture in Lahore.</p>,
                        source : "Rekhta",
                        render : ()=> <img alt="1880. Mohammad Husain Azad’s seminal work, Aab-e-Hayat (water of life) on the history of Urdu language published. Azad was a part of the Urdu writers who migrated from Delhi to Lahore after the War of 1857 and initiated the beginnings of an Urdu literary culture of Lahore." src={AabeHayatJPG} style={{width: '50%', marginLeft: '25%'}}></img>,
                      },
                      {
                        description : <p>
                          A linguist and educator, Gottlieb W. Leitner was appointed the Principal of Government College Lahore in 1864. While at the Government College, Lietner set up the <i>Anjuman-i-Ishat-i-Matalib-i-Mufida-i-Punjab</i> - ‘The society for the diffusion of useful knowledge in Punjab’, whose prime objective was the propagation of literary and scientific knowledge in vernacular languages. The photo shows the title page of Leitner's book - <i>The Languages and Races of Dardistan</i>.
                        </p>,
                        source : "https://www.lotsearch.net/",
                        render : ()=> <img alt="A linguist and educator, Gottlieb W. Leitner was appointed the Principal of Government College Lahore in 1864. While at Government College. LietnerLeitner set up the Anjuman-i-Ishaat-i-Mutalib-i-Mufida-i-Punjab, ‘The society for the diffusion of useful knowledge’, whose prime objective was the diffusion of literary and scientific knowledge in vernacular languages. The photo shows title page of Leitner's book 'The Languages and races of Dardistan'. Dardistan was a term coined by Leitner for Norther Indian regions including Kashmir" src={dardistan} style={{width: '95%', marginLeft: '2.5%'}}></img>,
                      },
                      {
                        description : <p>The Urdu poet Maulana Altaf Hussain Hali migrated to Lahore in 1869 to work at the Government Book Depot and stayed till 1874. He used to partake in the mushairas organized by the <i>Anjuman-i-Punjab</i></p>,
                        source : "Wikipedia",
                        render : ()=> <img alt="The Urdu poet Maulana Altaf Hussain Hali migrated to Lahore in 1869 to work at the Government Book Depot and stayed till 1874. He used to partake in the mushairas organized by the Anjuman-i-Punjab" src={Hali} style={{width: '40%', marginLeft: '30%'}}></img>,
                      }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter1",
        next : "chapter1slide2",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter1slide2" : {
        slideName : "The Mall: a literary hub",
        component : (
          <Slide bgImage={Slide2Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="The Mall: a literary hub" subtitle="Migrated writers settle in areas around The Mall"/>
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div>
                              <p className={classNames(slideStyles.slidePara, slideStyles.white)}>
                                The development of Lahore as a newly created centre for Urdu literary movements after the Partition is often associated with the migration of prominent Muslim literary figures to Lahore from North India, especially East Punjab. Many of the migrated writers and poets found the Upper Mall area of the city to be a lot like Delhi, something they were familiar with.
                              </p>
                              <p className={classNames(slideStyles.slidePara, slideStyles.white)}>
                                A lot of these literature scholars established affiliations with educational institutions such as the Punjab University, Government College, Islamia College, and the Dayal Singh College. All of these were in close proximity to each other on the Mall Road. Thus, the Mall soon became a hub for literary scholars and consequently became the centre for literary movements in the city.
                              </p>
                            </div>
                          </div>
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div id={imageStyles.lit19_Gallery_1} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                              <img src={Mall} className={classNames(imageStyles.hover_effect)} alt="Street View of the Mall" style = {{'width': '100%'}}/>
                            </div>
                          </div>
                        </Layout>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.lit19_Gallery_2} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="Anarkali Bazaar" className={classNames(imageStyles.hover_effect)} src={Anarkali}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.lit19_Gallery_3} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Bhaati Gate" className={classNames(imageStyles.hover_effect)} src={Bhaati}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.lit19_Gallery_4} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Government College" className={classNames(imageStyles.hover_effect)} src={GC}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : <p>
                            Most of the literary scholars that moved into the city after the Partition had settled in the posh areas of the Upper Mall, along with such middle-class localities as Krishan Nagar, Lakshmi Chowk, and Bhatti Gate. Cafes and restaurants on the Mall also attracted literary scholars to relax, debate, and exchange ideas, essays, and poetry.  The Pak Tea House, Nagina Bakery, Arab Hotel, and the extremely popular Cafe Orient were a few of the places frequented by literary figures
                          </p>,
                          source : "Lahore City History, http://city-history.com/",

                          render : ()=> <img alt="Street View of the Mall" src={Mall} style={{width: '85%', marginLeft: '7.5%'}}></img>,
                        },
                        {
                          description : <p>
                            The Anarkali Bazar, c.1947. The Anarkali Bazar was a central area surrounded by places of education such as the Government College, Punjab University, Islamia College, and Dayal Singh College. As a result of this, its small coffee shops and cafes were often frequented by major personalities in Lahore’s literary scene.
                          </p>,
                          source : "Lahore City History, http://city-history.com/",
                          render : ()=> <img alt="Anarkali" src={Anarkali} style={{width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <p>
                            The Bhatti gate was also an important location as it was in close proximity to the Government College and Islamia College. It was known for its small Kebab shops, which were often frequented by important literary personalities.
                          </p>,
                          source : "",
                          render : ()=> <img alt="Bhaati gate" src={Bhaati} style={{width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : <p>
                            The Government College served as a host to a lot of literary meetings. A number of <i>mushairas</i> were also held in the college. Poets such as Nafees Khalili, Abid Ali Abid, and Abdul Majeed Bhatti would often present their work at such events held at the College.
                          </p>,
                          source : "Lahore City History, http://city-history.com/",
                          render : ()=> <img alt="Government College" src={GC} style={{width: '80%', marginLeft: '10%'}}></img>,
                        }
                        ]
                      }
                    />
                  </div>
                </div>
              )}}
            </Slide>
        ),
        prev : "chapter1slide1",
        next : "chapter1slide3",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter1slide3" : {
        slideName : "Pak Tea House",
        component : (
          <Slide bgImage={Slide3Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading title="Pak Tea House" subtitle="A meeting place for writers and poets"/>
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div>
                              <p className={classNames(slideStyles.slidePara)}>
                                The site of the famous Pak Tea House was initially home to the Coffee House, later the India Tea house. After 1947, it was given to a refugee named Siraj who renamed it as the Pak Tea House. The initial use of the space as the Coffee House was sponsored by the Coffee Board set up by the Indian government in the 1930s. Coincidentally, the Coffee House had been set up at a time when Communist ideas had captured the imagination of a new generation of Indian youth, intellectuals and political workers. Owing to this, the space became the meeting place for the Leftists. The place was central to Lahore’s literary scene as well, especially after it became the meeting place of the Progressive Writers’ Association. It was also frequented by literary figures who did not have a direct link with the Progressive Writers’ Movement.
                              </p>
                            </div>
                          </div>
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div id={imageStyles.PTH_Gallery_1} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                              <img src={PTHMap} className={classNames(imageStyles.hover_effect)} alt="Pak Tea House, a central location to all literary hubs around the Mall"/>
                            </div>
                          </div>
                        </Layout>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.PTH_Gallery_2} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="A group of patrons at the Pak Tea House. Famous revolutionary poet, Habib Jalib is also photographed (seated third from right)" className={classNames(imageStyles.hover_effect)} src={PakT1}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.PTH_Gallery_3} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="A poet recites as Faiz Ahmad Faiz (seated second from right) and others listen" className={classNames(imageStyles.hover_effect)} src={PakT2}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.PTH_Gallery_4} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Facade of the famous Pak Tea House" className={classNames(imageStyles.hover_effect)} src={PakT3}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.PTH_Gallery_5} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="A group of patrons at the Pak Tea House" className={classNames(imageStyles.hover_effect)} src={PakT4}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : "The map shows the Government College, Punjab University, and Dayal Singh College. Right in the middle, on the Robert road, stands the famous Pak Tea House next to the YMCA hall, where the Progressive Writers’ Movement and the Halqa-e-Arbab-e-Zauq would often hold their meetings. It also hosted the All Pakistan Progressive Writers’ Association’s first ever meeting.",
                          source : "",

                          render : ()=> <img alt="Pak Tea House, a central location to all literary hubs around the Mall" src={PTHMap} style={{width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : "A group of patrons at the Pak Tea House. Famous revolutionary poet, Habib Jalib is also photographed (seated third from right)",
                          source : "DAWN",
                          render : ()=> <img alt="A group of patrons at the Pak Tea House. Famous revolutionary poet, Habib Jalib is also photographed (seated third from right)" src={PakT1} style={{width: '90%', marginLeft: '5%'}}></img>,
                        },
                        {
                          description : "A poet recites as Faiz Ahmad Faiz (seated second from right) and others listen",
                          source : "DAWN",
                          render : ()=> <img alt="A poet recites as Faiz Ahmad Faiz (seated second from right) and others listen" src={PakT2} style={{width: '90%', marginLeft: '5%'}}></img>,
                        },
                        {
                          description : "Facade of the famous, Pak Tea House",
                          source : "DAWN",
                          render : ()=> <img alt="Facade of the famous, Pak Tea House" src={PakT3} style={{width: '84%', marginLeft: '8%'}}></img>,
                        },
                        {
                          description : "A group of patrons at the Pak Tea House. Intizar Hussain, a prominent member of the Halqa Arbab-e-Zouq, is seated (second from right) on the lower table. Poet Nasir Kazmi accompanies on the same table (left)",
                          source : "DAWN",
                          render : ()=> <img alt="A group of patrons at the Pak Tea House" src={PakT4} style={{width: '100%', marginLeft: '0%'}}></img>,
                        }
                        ]
                      }
                    />
                  </div>
                </div>
              )}}
            </Slide>
        ),
        prev : "chapter1slide2",
        next : "chapter2",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      }

    }
  },
  "chapter2" : {
    name : "Chapter 2: The Progressive Writer's Association",
    slides : {
      "chapter2" : {
        component : (
          <Slide bgImage={Chapter2Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                      <ChapterTitle
                        inverted
                        chapter_number="2"
                        chapter_title="The Progressive Writers' Association"
                        subtitle = "انجمن ترقی پسند مصنفین"
                        urduSub
                        addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                        images={[
                          {image: FaizSajjad, id: chTStyles.absoluteFaizSajjad, shift : -12},
                        ]}
                      />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(84, 110, 122, .0) 0%,rgba(84, 110, 122, .48) 48%,rgba(84, 110, 122, .86) 97%,rgba(84, 110, 122, 1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter1slide3",
        next : "chapter2slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter2slide1" : {
        slideName : "Overview",
        component : (
          <Slide bgImage={Slide4Back} absoluteImage={{src: PWALogo, id: imageStyles.absolutePWALogo}}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={layoutStyles.layout_100}>
                        <SlideHeading
                          noPadding
                          title="Progressive Writers' Association (PWA) in Lahore"
                          desc=<div>The Progressive Writers’ Movement was extremely prominent among the literary movements of Lahore. The Progressive Writers’ Movement operated in a doctrinal triangle whose three nodes were pragmatism, Marxism, and a western orientation. The group was left-oriented, and sought to inspire people through their writings advocating equality among all humans and attacking social injustice in the society. Its members included notable literary personalities such as Faiz Ahmed Faiz, Sibt-e-Hasan, Habib Jalib, Ahmed Faraz, Ali Sardar Jafri, Sadat Hasan Manto, Ahmed Nadeem Qasmi, Hameed Akhtar and Sahir Ludhianvi . The association had its own publication as well - a magazine by the name of <i>Nizam</i>. Intizar Hussain - though he did not share leftist leanings - served as the editor of <i>Nizam</i> in its early years and writes fondly of the discourse that was prevalent in the publication.</div>
                        />
                      </div>
                    </Layout>
                  </div>
                </div>
            )}}
          </Slide>
        ),
        prev : "chapter2",
        next : "chapter2slide2",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter2slide2" : {
        slideName : "Formation",
        component : (
          <Slide bgImage={Slide5Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Formation of PWA" subtitle=<div><i>Angaray</i> causes a literary upheaval</div>/>
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div>
                              <p className={classNames(slideStyles.slidePara, slideStyles.white)}>
                                The foundations of the PWA were set by the publication of <i>Angaray</i>, an anthology of short stories by Sajjad Zaheer, Ahmed Ali, Dr Rashid Jahan and Mahmud-uz-Zafar in 1932-33. Deemed to have breached socio-religious norms around marriage and sexuality, <i>Angaray</i> was described as “nakedly vulgar”, pulled off shelves and even banned by the Uttar Pradesh Government. <i>Angaray</i> opened the much-feared debate on literary content, boundaries and authority to determine what can and cannot be discussed in society. This paved the way for the PWA as a space for such debates. With the growth of the PWA after its creation by these progressive writers in 1939, the canon was captured and shaped by it, beginning a new phase in the literary culture of Lahore and colonial India.
                              </p>
                              <p className={classNames(slideStyles.slidePara, slideStyles.white)}>
                                Sajjad Zaheer and his contemporaries paved the path for and created the PWA, with its first manifesto appearing in London in 1936. PWA’s inaugural meeting was held in Lucknow in June 1939, where notable literary figures joined the movement and Munshi Premchand declared the PWA’s mission to enlighten and bring about “new experience”.
                              </p>
                            </div>
                          </div>
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div id={imageStyles.angaaray_gallery1} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                              <img src={AngarayTitle} className={classNames(imageStyles.hover_effect)} alt="Title page of the book Angaarey" style = {{'width': '100%'}}/>
                            </div>
                          </div>
                        </Layout>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.angaaray_gallery2} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="Authors of Angaarey, Rashid Jahan (second from right) and Mahmuduzzafar (extreme left)" className={classNames(imageStyles.hover_effect)} src={AngarayTeam}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.angaaray_gallery4} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Police Notice about 'Angaray', published in the U.P Gazette 1933" className={classNames(imageStyles.hover_effect)} src={AngarayEng}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.angaaray_gallery5} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Sajjad Zaheer, the leading force behind the Progressive Writers' Association" className={classNames(imageStyles.hover_effect)} src={SajjadZah}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : <p>Title page of the book <i>Angaray</i></p>,
                          source : "",

                          render : ()=> <img alt="Title page of the book Angaray" src={AngarayTitle} style={{width: '50%', marginLeft: '25%'}}></img>,
                        },
                        {
                          description : <p>
                            Authors of <i>Angaray</i>, Rashid Jahan (second from right) and Mahmud-uz-Zafar (extreme left)
                          </p>,
                          source : "Herald, DAWN",
                          render : ()=> <img alt="Authors of Angaray, Rashid Jahan (second from right) and Mahmud-uz-Zafar (extreme left)" src={AngarayTeam} style={{width: '80%', marginLeft: '10%'}}></img>,
                        },
                        {
                          description : <p>
                            Official excerpts and publications condemning <i>Angaray</i> and its circulation in society. The British colonial state, despite its secular pretense, struggled with such a direct re-introduction of the private into its controlled public, colonial space. <i>Angaray</i> not only challenged literary values and norms, socio-religious outlooks and the state, but an entire system of existence.
                          </p>,
                          source : "DAWN",
                          render : ()=> <img alt="Police Notice about 'Angaray', published in the U.P Gazette 1933" src={AngarayEng} style={{width: '60%', marginLeft: '20%'}}></img>,
                        },
                        {
                          description : "Sajjad Zaheer, the leading force behind the Progressive Writers' Association",
                          source : "",
                          render : ()=> <img alt="Sajjad Zaheer, the leading force behind the Progressive Writers' Association" src={SajjadZah} style={{width: '40%', marginLeft: '30%'}}></img>,
                        }
                        ]
                      }
                    />
                  </div>
                </div>
              )}}
            </Slide>
        ),
        prev : "chapter2slide1",
        next : "chapter2slide3",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter2slide3" : {
        slideName : "Political Debates",
        component : (
          <Slide bgImage={Slide6Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Progressive Writers' Association" subtitle="Political Debates" desc = "Intizar Hussain writes that the topics of discussion in 1947-49 were often centred around the politics of Partition. In fact, it can be said that one of the reasons that the literary scholars of Lahore were so active at that time was that there was a lot to talk about. The socio-political changes that the world was going through following the defeat of the Third Reich in World War II had given writers and thinkers a plethora of topics and ideas to discuss and debate. Sentiments were high and a lot of thinkers and scholars - especially those with a progressive outlook - expressed reservations about the trajectory taken by the newly established state of Pakistan. However, there were also a lot of writers that called for loyalty to the newly created state of Pakistan and critiqued the writers speaking against it. One of them was the well renowned critic and intellectual, Professor Muhammad Hassan Askari. This conflict of ideas generated a vibrant literary and intellectual culture."/>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.PWAPolitics1} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img src={PWA_Politics} alt="Muhammad Hasan Askari, Saleem Ahmad and Intizar Hussain" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.PWAPolitics2} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img src={PWAPolitics} alt="Sibt-e-Hasan, Faiz Ahmed Faiz, Hameed Akhtar and Ahmed Nadeem Qasmi" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "Pictured left to right: Muhammad Hasan Askari, Saleem Ahmad and Intizar Hussain. Muhammad Hasan Askari was known to be close friends with Intizar Hussain. He also contributed a lot to the political discourse in Lahore at the time by bringing up ideas of cultural Islamism and loyalty to the Pakistani state.",
                        title : "Sample Title",
                        source : "Flickr",
                        render : ()=> <img alt="Muhammad Hasan Askari, Saleem Ahmad and Intizar Hussain" src={PWA_Politics} style={{width: '80%', marginLeft: '10%'}}></img>,
                      },
                      {
                        description : "Pictured left to write: Sibt-e-Hasan, Faiz Ahmed Faiz, Hameed Akhtar and Ahmed Nadeem Qasmi. All four were prominent members of the Anjuman and would often frequent their meetings and engage in political debates about Communism and the newly created state of Pakistan.",
                        title : "Sample Title",
                        source : "Herald, DAWN",
                        render : ()=> <img alt="Sibt-e-Hasan, Faiz Ahmed Faiz, Hameed Akhtar and Ahmed Nadeem Qasmi" src={PWAPolitics} style={{width: '80%', marginLeft: '10%'}}></img>,
                      }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide2",
        next : "chapter2slide4",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter2slide4" : {
        slideName : "Philosophy",
        component : (
          <Slide bgImage={Slide5Back}>
             {(props) => {
               return (
                 <div className={slideStyles.slideflex}>
                   <SlideHeading inverted title="Progressive Writers' Association" subtitle = "Philosophy"/>
                   <div className={slideStyles.slideContent}>
                     <Layout layoutClassName="layout_flexed">
                       <div ref={props.addParallaxAndFadeRef(8)} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                          <p className={classNames(slideStyles.slidePara, slideStyles.white)}>
                            The PWA was a pan-Indian organization with links to various foreign and political groups espousing similar ideas about life, literature, politics and revolution. The PWA began as just another “self-selecting literary club”, banding together poets and writers who endorsed progress, a loose term with a large range of meanings. As the general literary context began incorporating political and social commentary in it, the PWA defined progress by attaching literature with social action. While PWA’s political associations were not pronounced initially, they became stark and reinforced the growing demarcations of literary stances.
                          </p>
                          <p className={classNames(slideStyles.slidePara, slideStyles.white)}>The PWA emphasized the importance of <i>sayasat</i> (political), <i>samaj</i> (society), <i>maqsad</i> (purpose) and <i>mahol</i> (ambiance) as key to literary production. It aimed at heralding social change by highlighting the injustices and bitter realities of life and bringing literature closer to the lives of the dispossessed. The PWA treated the past as the era of degeneration and the present as the opportunity to reform society through the power of literature.</p>
                       </div>
                       <div className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div ref={props.addParallaxAndFadeRef(15)} id={imageStyles.PWA_MaulviAH} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                          <img src={PWA_MaulviAH} alt="Members of the Progressive Writers' Association" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                     </Layout>
                    </div>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : <div>
                            <p>
                              Top picture: Left to right: Sibt-e-Hasan, Maulvi Abdul Haq, Mazhar Ali Khan, and Ahmed Nadeem Qasmi at a literary jalsa in the 1950s. Faiz and Sajjad Zaheer were in jail at this point.
                            </p>
                            <p>
                              Bottom picture: Sajjad Zaheer and Faiz Ahmad Faiz
                            </p>
                          </div>,
                          title : "Sample Title",
                          source : "DAWN/ Flickr",
                          render : ()=> <img alt="Members of the Progressive Writers' Association" src={PWA_MaulviAH} style={{width: '56%', marginLeft: '22%'}}></img>,
                        }]
                      }
                    />
                 </div>
               )
             }}
          </Slide>
        ),
        prev : "chapter2slide3",
        next : "chapter2slide5",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter2slide5" : {
        slideName : "Personalities",
        component : (
          <Slide bgImage={Slide6Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Progressive Writers' Association" subtitle="Personalities" desc = "Click on the photos for profiles"/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAPersGall1} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                            <img alt="Sajjad Zaheer" className={classNames(imageStyles.hover_effect)} src={SajjadZaheerGall}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16)}>Sajjad Zaheer</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAPersGall2} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="Faiz's stamp" className={classNames(imageStyles.hover_effect)} src={FaizStamp}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16)}>Faiz Ahmad Faiz</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAPersGall3} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Hasan Askari" className={classNames(imageStyles.hover_effect)} src={HasanAskari}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16)}>Hasan Askari</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAPersGall4} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Sibt-e-Hasan" className={classNames(imageStyles.hover_effect)} src={SibteHasan}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16)}>Sibt-e-Hasan</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(7)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAPersGall5} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Abdullah Malik" className={classNames(imageStyles.hover_effect)} src={AbdulMalik}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16)}>Abdullah Malik</p>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p>
                          Sajjad Zaheer was one of the most influential members of the Progressive Writers’ Association. PWA’s first international conference was held in the Falletti’s Lahore in 1949. In this conference, a few Russian literary figures also participated. The Russian guests, while sitting in a room with Ahmed Nadeem Qasmi, Hajra Masroor, Khadija Mastoor, Safdar Mir, and Abdullah Malik, inquired about the founder of the Progressive Writers’ Movement. In response to this query, everyone in the room collectively replied with Sajjad Zaheer’s name. Zaheer also became the Secretary General of the Pakistan Communist Party. He lived in Lahore for a few years before travelling to Karachi to establish the presence of the Community Party there. While in Lahore, he lived near Anarkali Bazar on Dhani Ram road and later on Davis road and then Jail Road. After living in Karachi for a few years, he left for India.
                        </p>,
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Sajjad Zaheer" src={SajjadZaheerGall} style={{width: '65%', marginLeft: '17.5%'}}></img>,
                      },
                      {
                        description : <p>
                          One of the most prominent poets of Pakistan, Faiz became the flagbearer of revolutionary literature. His professional career included his time as a lecturer of English in MAO College in the late 1930s and chief editor of the Daily <i>Imroz</i>. As a poet of socialist leaning, Faiz did not fare too well with the Pakistani state and was jailed during the 1950s for his alleged role in a conspiracy to overthrow the government.
                        </p>,
                        title : "Sample Title2",
                        source : "",
                        render : ()=> <img alt="Faiz's stamp" src={FaizStamp} style={{width: '50%', marginLeft: '25%'}}></img>,
                      },
                      {
                        description : <p>
                          In 1948, Hasan Askari wrote an essay that was published in the <i>Nizam</i> Magazine. He taunted the literary personalities of the time by associating them with Kipling’s <i>Bandar log</i> and accusing renowned and well-respected scholar Ali Sardar Jafri of frequenting the Café Orient solely because of the pretty Anglo-Indian hostess. The essay rejected the Progressive Writers Movement’s ideas about literature. It taunted the literati of Lahore and accused them of being disloyal to the state of Pakistan. From then on, Hasan Askari adopted an ‘Islamic approach’ in literature.
                        </p>,
                        title : "Sample Title2",
                        source : "Flickr",
                        render : ()=> <img alt="Hasan Askari" src={HasanAskari} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '52%', marginLeft: '24%'}}></img>,
                      },
                      {
                        description : <p>
                          Sibt-e-Hasan came to Lahore after the Partition and stayed in the Falletti’s hotel for a few days and left it as he found the hotel too sterilized and conventional for his taste . He entered the country on a fake name and passport. He remained the underground editor while Hameed Akhtar was the face of the newspaper. He resided in the Naqi building behind the Mall road, which became the epicenter of many literary activities in the city at that time.
                        </p>,
                        title : "Sample Title2",
                        source : "Goodreads",
                        render : ()=> <img alt="Sibt-e-Hasan" src={SibteHasan} style={{width: '70%', marginLeft: '15%'}}></img>,
                      },{
                        description : <p>
                          Abdullah Malik was a prominent member of the All India Communist Party, and took an active part in the political and social events in the country. He regularly attended the weekly literary circles that took place in various cities, where issues of social reform were discussed by political leaders and intellectuals alike. It was in Mumbai, in the year 1943, that Malik began to appear in literary circles as well as political rallies and meetings. He writes about how he was introduced to many literary figures through his friend, Sajjad Zaheer. On the 24th of May of the same year, the Progressive Writers Association had its fourth meeting, where many prominent figures such as Saghir Nizam, Krishan Chandar and others were present. It was at this conference that Malik came to realize that language had to be a central concern of any literary movement in India. He saw that each of these literary figures spoke and wrote in their own regional languages. He writes about how in these years, the attack on Indian culture was most viciously being carried out by the colonizer. It was in this context, he wrote, that it became a necessity to write and to produce works in the vernacular.
                        </p>,
                        title : "Sample Title2",
                        source : "DAWN",
                        render : ()=> <img alt="Abdullah Malik" src={AbdulMalik} style={{width: '40%', marginLeft: '30%'}}></img>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide4",
        next : "chapter2slide6",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter2slide6" : {
        slideName : "Pictures and letters",
        component : (
          <Slide bgImage={Slide5Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading inverted title="Progressive Writers' Association" subtitle="Pictures and letters"/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAGall1} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                            <img alt="Abdullah Malik and Faiz Ahmad Faiz" className={classNames(imageStyles.hover_effect)} src={AM_Faiz}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAGall2} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="Abdullah Malik and Sajjad Zaheer" className={classNames(imageStyles.hover_effect)} src={AM_SZ}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(8)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAGall3} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Eminent PWA members" className={classNames(imageStyles.hover_effect)} src={Faiz_AM}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAGall4} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="Sibt-e-Hasan, Dr M. Sarwar and Faiz Ahmed Faiz" className={classNames(imageStyles.hover_effect)} src={Faiz_SH}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAGall5} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Sajjad Zaheer and Faiz Ahmed Faiz" className={classNames(imageStyles.hover_effect)} src={Faiz_SZ}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.PWAGall6} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="Ali Sardar Jafri, Sibt-e-Hasan, Ismat Chughtai and Amna Majeed Malik." className={classNames(imageStyles.hover_effect)} src={SH_Ismet}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(7)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAGall7} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                            <img alt="A letter from Faiz to Hameed Akhtar" className={classNames(imageStyles.hover_effect)} src={FaizLetter1}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Faiz's Letter to Hameed Akhtar (1)</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAGall8} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",7])}>
                            <img alt="A letter from Faiz to Hameed Akhtar" className={classNames(imageStyles.hover_effect)} src={FaizLetter2}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Faiz's Letter to Hameed Akhtar (2)</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAGall9} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",8])}>
                            <img alt="A letter from Faiz to Hameed Akhtar" className={classNames(imageStyles.hover_effect)} src={FaizLetter3}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Faiz's Letter to Hameed Akhtar (3)</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-7)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAGall10} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",9])}>
                            <img alt="A letter from Sibt-e-Hasan to Hameed Akhtar" className={classNames(imageStyles.hover_effect)} src={SHLetter1}/>
                          </div>
                          <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Sibt-e-Hasan's Letter to Hameed Akhtar</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAGall11} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",10])}>
                            <img alt="Roshnai, a book by Sajjad Zaheer" className={classNames(imageStyles.hover_effect)} src={Roshnai}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.PWAGall12} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",11])}>
                            <img alt="Sibt-e-Hasan's book 'Musa se Marx' tak" className={classNames(imageStyles.hover_effect)} src={MusaMarx}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "Abdullah Malik (right) pictured with comrade and friend Faiz Ahmed Faiz.",
                        title : "Sample Title",
                        source : "The Friday Times",
                        render : ()=> <img alt="Abdullah Malik and Faiz Ahmad Faiz" src={AM_Faiz} style={{width: '65%', marginLeft: '17.5%'}}></img>,
                      },
                      {
                        description : "Abdullah Malik (second from the right) receiving prominent writer and Marxist Sajjad Zaheer (centre). ",
                        title : "Sample Title2",
                        source : "The Friday Times",
                        render : ()=> <img alt="Abdullah Malik and Sajjad Zaheer" src={AM_SZ} style={{width: '70%', marginLeft: '15%'}}></img>,
                      },
                      {
                        description : "Mazhar Ali Khan (second from the left) with Faiz Ahmed Faiz next to him, laden with flowers. On the right stands Abdullah Malik.",
                        title : "Sample Title2",
                        source : "The Friday Times",
                        render : ()=> <img alt="Eminent PWA members" src={Faiz_AM} style={{width: '70%', marginLeft: '15%'}}></img>,
                      },
                      {
                        description : "Sibt-e-Hasan, Dr M. Sarwar and Faiz Ahmed Faiz",
                        title : "Sample Title2",
                        source : "The Friday Times",
                        render : ()=> <img alt="Sibt-e-Hasan, Dr M. Sarwar and Faiz Ahmed Faiz" src={Faiz_SH} style={{width: '85%', marginLeft: '7.5%'}}></img>,
                      },{
                        description : <p>
                          Sajjad Zaheer and Faiz Ahmed Faiz, significant members of the PWA. Sajjad Zaheer had financed the publication of <i>Angaray</i> himself, determined to change the course of literary traditions for Indian literary circles. A new wave of literary understanding emerged and gained momentum, as notions of progress, social disparities and reality were featured vehemently in literary works.
                        </p>,
                        title : "Sample Title2",
                        source : "Flickr",
                        render : ()=> <img alt="Sajjad Zaheer and Faiz Ahmed Faiz" src={Faiz_SZ} style={{width: '70%', marginLeft: '15%'}}></img>,
                      },
                      {
                        description : "Ali Sardar Jafri seated on the right. Next to him is Sibt-e-Hasan, then Ismat Chughtai, and the second from the left is Amna Majeed Malik.",
                        title : "Sample Title2",
                        source : "DAWN",
                        render : ()=> <img alt="Ali Sardar Jafri, Sibt-e-Hasan, Ismat Chughtai and Amna Majeed Malik." src={SH_Ismet} style={{width: '75%', marginLeft: '12.5%'}}></img>,
                      },
                      {
                        description : "A letter from Faiz to Hameed Akhtar",
                        title : "Sample Title2",
                        source : "",
                        render : ()=> <img alt="A letter from Faiz to Hameed Akhtar" src={FaizLetter1} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '62%', marginLeft: '19%'}}></img>,
                      },
                      {
                        description : "A letter from Faiz to Hameed Akhtar",
                        title : "Sample Title2",
                        source : "",
                        render : ()=> <img alt="A letter from Faiz to Hameed Akhtar" src={FaizLetter2} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '62%', marginLeft: '19%'}}></img>,
                      },
                      {
                        description : "",
                        title : "A letter from Faiz to Hameed Akhtar",
                        source : "",
                        render : ()=> <img alt="A letter from Faiz to Hameed Akhtar" src={FaizLetter3} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '62%', marginLeft: '19%'}}></img>,
                      },
                      {
                        description : "A letter from Sibt-e-Hasan to Hameed Akhtar (8 August, 1983)",
                        title : "Sample Title2",
                        source : "",
                        render : ()=> <img alt="A letter from Sibt-e-Hasan to Hameed Akhtar (August 8, 1983)" src={SHLetter1} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '62%', marginLeft: '19%'}}></img>,
                      },
                      {
                        description : <p><i>Roshnai</i>, a book by Sajjad Zaheer presents the history of the Progressive Writers' Movement in India</p>,
                        title : "Sample Title2",
                        source : "Rekhta",
                        render : ()=> <img alt="Roshnai, a book by Sajjad Zaheer" src={Roshnai} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '56%', marginLeft: '22%'}}></img>,
                      },
                      {
                        description : <p>
                          Sibt-e-Hasan's book <i>Musa se Marx tak</i>. Many of the eminent PWA members were known for their ardent support for socialism in Pakistan
                        </p>,
                        title : "Sample Title2",
                        source : "The Friday Times",
                        render : ()=> <img alt="Sibt-e-Hasan's book 'Musa se Marx' tak" src={MusaMarx} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '50%', marginLeft: '25%'}}></img>,
                      }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide5",
        next : "chapter2slide7",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter2slide7" : {
        slideName : "Decline",
        component : (
          <Slide bgImage={Slide6Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Progressive Writers Association" subtitle="The Decline"
                  desc =
                  <div>
                      <p className = {classNames(slideStyles.slidePara_16)}>
                        Around 1949, the Progressive Writers’ Association took a different turn. In a meeting held at the flat of socialist intellectual and journalist, Mazhar Ali Khan, the Anjuman voted to bar any publication that did not conform to their socialist ideology. Consequently, writers such as Intizar Hussain and Hasan Askari were barred from writing and publishing anything in an Anjuman publication because of their opposition to the communist ideology. One of the reasons cited by Sibt-e-Hasan for his support for the decision was the successful communist revolution in China. The socialist intellectuals of Pakistan believed that by temporarily shutting down the voices of opposition in the wake of such a politically charged situation, they might be able to see a communist revolution in their own country as well. Sibt-e-Hasan later expressed regret at the decision in a personal letter addressed to Intizar Hussain.
                      </p>
                      <p className = {classNames(slideStyles.slidePara_16)}>
                        Over time, this decree was withdrawn, but the damage had been done to the reputation of PWA. Also, with the arrest of major Anjuman members such as Faiz, Sajjad Zaheer, and many others following the failure of the alleged 1951 Rawalpindi Conspiracy, the association lost its vigor. The state used it as an excuse to clamp down on progressive organizations.
                      </p>
                  </div>

                  />
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.PWADecline1} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img src={PWA_Politics} alt="Mohammad Hassan Askari and Intizar Hussain" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slideLabel, slideStyles.center_aligned_text)}>
                          Mohammad Hassan Askari (left) and Intizar Hussain (right) were barred from publishing in any of the <i>Anjuman</i> publications
                        </p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.PWADecline2} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img src={Manto} alt="Saadat Hasan Manto" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slideLabel, slideStyles.center_aligned_text)}>
                          Manto, the famous short story writer, was also excluded from the association in 1949
                        </p>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p>Mohammad Hassan Askari (left) and Intizar Hussain (right) were barred from publishing in any of the <i>Anjuman</i> publications</p>,
                        title : "Sample Title",
                        source : "Flickr",
                        render : ()=> <img alt="Mohammad Hassan Askari and Intizar Hussain" src={PWA_Politics} style={{width: '80%', marginLeft: '10%'}}></img>,
                      },
                      {
                        description : "Manto, the famous short story writer, was also exluded from the association in 1949",
                        title : "Sample Title",
                        source : "Herald, DAWN",
                        render : ()=> <img alt="Saadat Hasan Manto" src={Manto} style={{width: '80%', marginLeft: '10%'}}></img>,
                      }
                      ]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide6",
        next : "chapter3",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      }
    }
  },
  "chapter3" : {
    name : "Chapter 3: Halqa Arbab-e-Zouq",
    slides : {
      "chapter3" : {
        component : (
          <Slide bgImage={Chapter3Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <ChapterTitle
                      inverted
                      chapter_number="3"
                      chapter_title="Halqa Arbab-e-Zouq"
                      subtitle = "حلقہ ارباب ذوق"
                      urduSub
                      addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                      images={[{image: HAZLogo1, id: chTStyles.HAZLogo1, shift : 15},
                               {image: HAZLogo2, id: chTStyles.HAZLogo2, shift : -12}]}
                    />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(73,58,83,0) 0%,rgba(73,58,83,0.48) 48%,rgba(73,58,83,0.97) 97%,rgba(73,58,83, 1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide7",
        next : "chapter3slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter3slide1" : {
        slideName : "Overview",
        component : (
          <Slide bgImage={Slide7Back}>
             {(props) => {
               return (
                 <div className={slideStyles.slideflex}>
                   <SlideHeading title="Overview"/>
                   <div className={slideStyles.slideContent}>
                     <Layout layoutClassName="layout_flexed">
                       <div ref={props.addParallaxAndFadeRef(8)} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                          <p className={slideStyles.slidePara}>What began as an informal group for writers soon became an important literary collective and organization. Bazm-e-Dastangoyan’s name was changed to Halqa Arbab-e-Zauq in September 1939. Its procedures were formalized in 1940 when the group’s membership and social presence became a concern. Initially, its meetings were held at the residence of its members. In 1944, the group relocated permanently to the YMCA.</p>
                          <p className={slideStyles.slidePara}>The Halqa had also received a lot of criticism because it was wrongly perceived as a reaction to the Progressive Writers Movement and due to the literary leanings of some of its members who favoured the notion of art for art’s sake. This is despite the fact  that the Halqa’s annual publication had also promoted writers such as Josh whose poetry was aimed at social revolution. Either way, the Halqa housed and helped many famous as well as aspiring writers, such as Tabish Siddiqui, Ahmed Nadeem Qasmi, Rajinder Singh Bedi, Kanhaiya Lal Kapur and Qayyum Nazar. The organization is functional to this day.</p>
                       </div>
                       <div className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div ref={props.addParallaxAndFadeRef(15)} id={imageStyles.HalqaBook} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                          <img src={HalqaBook} alt="Title page of Dr Yunus Javed's book 'Halqa e Arbab-e-Zouq'" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                     </Layout>
                    </div>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : <p><i>Halqa Arbab-e-Zouq: Organization, Movement, Ideology</i> - a book on the history and literary activities of the Halqa by Dr. Yunus Javed</p>,
                          title : "Sample Title",
                          source : "Goodreads",
                          render : ()=> <img alt="Title page of Dr Yunus Javed's book 'Halqa e Arbab-e-Zouq'" src={HalqaBook} style={window.innerHeight > 675 ? {width: '56%', marginLeft: '22%'} : {width: '50%', marginLeft: '25%'}}></img>,
                        }]
                      }
                    />
                 </div>
               )
             }}
          </Slide>
        ),
        prev : "chapter3",
        next : "chapter3slide2",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter3slide2" : {
        slideName : "Personalities",
        component : (
          <Slide bgImage={Slide8Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading inverted title="Personalities"/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                      <div ref={props.addParallaxAndFadeRef(6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25_portrait)}>
                        <div id={imageStyles.Taabish} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                          <img alt="Taabish Siddiqui"  src={Taabish} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Taabish Siddiqui</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(-5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.SherMA} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                          <img alt="Sher Muhammad Akhtar"  src={SherMA} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Sher Muhammad Akhtar</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.QayyumNazar} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img alt="Qayyum Nazar"  src={QayyumNazar} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Qayyum Nazar</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.YusufZafar} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img alt="Yusuf Zafar"  src={YusufZafar} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Yusuf Zafar</p>
                      </div>

                      <div ref={props.addParallaxAndFadeRef(5.5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.IntizarHussain} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                          <img alt="Intizar Hussain"  src={IntizarHussain} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>IntizarHussain</p>
                      </div>

                      <div ref={props.addParallaxAndFadeRef(-4.5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25_portrait)}>
                        <div id={imageStyles.Miraji} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                          <img alt="Miraji"  src={Miraji} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16, slideStyles.white)}>Miraji</p>
                      </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p>
                          His actual name was Khawaja Abdul Qayyum Butt, but he wrote under the pen name Nazar, popularizing him as Qayyum Nazar. He was an eminent member of the Halqa and a poet. He was a professor at Government College Lahore and Punjab University.
                        </p>,
                        title : "",
                        source : "Rekhta",
                        render : ()=> <img alt="Qayyum Nazar" src={QayyumNazar} style={{width: '40%', marginLeft: '30%'}}></img>
                      },
                      {
                        description : <p>
                          Yusuf Zafar was a prominent member of the Halqa Arbab-e-Zauq who joined the group in its early phase and was appointed its Secretary. Zafar was a poet who had also abandoned the <i>ghazal</i> genre for the <i>nazam</i> format. Perhaps due to this change, Zafar had also joined the literary journal <i>Hamayun</i> in 1942, a publication that famously promoted the <i>jadeed nazam</i> (modern poem) . Due to this change, his work is clearly divided between his classical poetics and modern sensibility. Zafar had been one of the initial few members of the Halqa to back Miraji when he expressed the need for constructive, even oppositional, criticism to the works being read out in the meetings of the Halqa.
                        </p>,
                        title : "",
                        source : "Rekhta",
                        render : ()=> <img alt="Yusuf Zafar" src={YusufZafar} style={{width: '40%', marginLeft: '30%'}}></img>
                      },
                      {
                        description : <p>
                          Intizar Hussain’s time at the Halqa Arbab-e-Zauq led to a lot of contentions. As a literary critic, he was bound to be more critical of the form of the texts being presented at the meetings, which led to his clashes with other members. The charged political environment of the 50s had begun to reflect in the dynamics of the Halqa as well where differing 24th opinions had begun to split the group in 1954. However, the real trouble began for Hussain on 13 June 1954 when he criticized Amjad Altaf’s story “Nirvan” for its dialogical narrative style which he felt was incompatible with a psychological narrative. To this, Qayyum Nazar retorted that one cannot dictate the narrative style to a writer. Nazar also criticized Hussain’s own work for only having narrative techniques and no meat. Using this interaction as an excuse, Hussain was dismissed from the Halqa according to this notice from 16 June 1954.
                        </p>,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : ()=>
                          <div style = {window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}>
                            <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN5} vbx='800' vby='655' r='11'
                              hotspots={[
                                {x: '660', y: '210', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``}
                              ]}>
                            </HotspotImage>
                          </div>
                      },
                      {
                        description : <p className = {classNames(slideStyles.slidePara_16)}>
                          Miraji was an important literary figure and poet, recognized mostly for his eccentric lifestyle as well as poetry. He had a formative role to play in the development of the Halqa Arbab-e-Zauq. Miraji was inducted into the Halqa on 25 August 1940. He placed a lot of emphasis on the appreciation of art by ensuring that writers were not just praised (in the form of chants of <i>wah wah</i>) but also provided with constructive criticism and debate regarding their work. Because this was an uncommon practice at the time, his efforts led to a split in the Halqa with one group favoring uncritical appreciation of poetry and the other leaning towards a more critical reception. Miraji was also an avid defender of art for art’s sake. He argued that those who criticize classical Urdu literature for being out of touch with the realities of life are misguided because all emotions and expression are essentially rooted in the human experience. He also believed that art for life’s sake cannot exist if one does not first realise the necessity of art on its own. Miraji also took up a managerial role in the Halqa. Having first lost to Muhammad Akhtar as President of the Halqa, he later went on to take the same role, presiding over the debates as well as the publications.
                        </p>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Miraji" src={Miraji} style={{width: '50%', marginLeft: '25%'}}></img>
                      },
                      {
                        description : <p className = {classNames(slideStyles.slidePara_16)}>
                          Siddiqui was a renowned poet and one of the earliest members of the Halqa Arbab-e-Zouq who had hosted its initial meetings at his residence in Javed Manzil, Rahim Road in Misri Shah before the Halqa had any fixed, official location. The photo shows Siddiqui’s poem published in the newspaper, <i>Inqilab</i>
                        </p>,
                        title : "",
                        source : "",
                        render : ()=> <img alt="Taabish Siddiqui" src={Taabish} style={{width: '70%', marginLeft: '15%'}}></img>
                      },
                      {
                        description : <p className = {classNames(slideStyles.slidePara_16)}>
                          <p>
                          Akhtar was one of the leading figures in the creation of the Halqa Arbab-e-Zouq and an affiliate of the <i>Anjuman Himayat-e-Islam</i>. In fact, the Halqa was his and Naseer Ahmed Jamai’s brainchild. The two had realized the need for a place where writers could merely sit and talk. Hence, they began the Halqa without an actual literary or political agenda in mind. The Halqa was initially named the Bazm-e-Dastangoya and its first session was held at Akhtar's house called the Lakshmi Mansion on McLeod Road. At the same time, Akhtar was also associated with the <i>Anjuman Himayat-e-Islam</i>.
                          </p>
                          <p>
                            The picture shows title page of Akhtar's book, <i>'Lo ek Qissa Suno'</i>
                          </p>

                        </p>,
                        title : "",
                        source : "Rekhta",
                        render : ()=> <img alt="Sher Muhammad Akhtar" src={SherMA} style={{width: '30%', marginLeft: '35%'}}></img>
                      }]
                    }
                    />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter3slide1",
        next : "chapter3slide3",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter3slide3" : {
        slideName : "Notes from Halqa's meetings",
        component : (
          <Slide bgImage={Slide7Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Notes from Halqa's meetings"/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                      <div ref={props.addParallaxAndFadeRef(5.5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.HN1} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img alt="Halqa Arbab-e-Zouq Notes"  src={HN1} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16)}>16 Feb 1942</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(-5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                        <div id={imageStyles.HN3} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img alt="Halqa Arbab-e-Zouq Notes"  src={HN2} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16)}>16 Feb 1942</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(4.5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.HN2} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                          <img alt="Halqa Arbab-e-Zouq Notes"  src={HN3} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16)}>14 Dec 1948</p>
                      </div>

                      <div ref={props.addParallaxAndFadeRef(-4.5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.HN4} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                          <img alt="Halqa Arbab-e-Zouq Notes"  src={HN4} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16)}>9 May 1950</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.HN5} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                          <img alt="Halqa Arbab-e-Zouq Notes"  src={HN5} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <p className = {classNames(slideStyles.slidePara_16)}>16 June 1954</p>
                      </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description :
                        <p>
                          <p>
                            Meeting notes from 16 February 1942 mention Qayyum Nazar, Miraji, Yusuf Zafar and Sher Muhammad Akhtar.
                          </p>
                          <p>
                            <i>Behtereen Nazmein</i>: The Halqa had begun a tradition of publishing a selection of the best poems that had been published the previous year. This tradition began in 1942 and the archive shows that the first selection committee comprised of Muhammad Akhtar, Qayyum Nazar and Miraji who were entrusted with selecting the best publications of the previous year from nation-wide literary magazines. The collection consisted of poems by authors such as Ahmed Nadeem Qasmi, Faiz Ahmed Faiz, Josh Maleehabadi, Nazar and N. M. Rashid.
                          </p>
                        </p>,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : ()=>
                          <div style = {window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}>
                            <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN1} vbx='800' vby='1040' r='11'
                              hotspots={[
                                {x: '450', y: '280', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                                {x: '675', y: '325', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                                {x: '690', y: '435', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``}
                              ]}>
                            </HotspotImage>
                          </div>
                      },
                      {
                        description : <p>
                          Miraji’s original signature (proceedings of Halqa Arbab-e-Zauq, 16 February 1942)
                        </p>,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : () =>
                          <div style = {window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}>
                            <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN2} vbx='800' vby='636' r='11'
                              hotspots={[
                                {x: '625', y: '335', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                                {x: '650', y: '150', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true},
                                {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                              ]}>
                            </HotspotImage>
                          </div>
                      },
                      {
                        description : <p>
                          The meeting’s location has been recorded as ‘India Tea House’ which was the predecessor to the Pak Tea House. Before the Partition, the India Coffee House and the India Tea House were “the two most popular meeting places of the intellectual and literary coteries”. However, this meeting, which was recorded in 1948 still uses the name India Tea House, showing that the switch was more gradual since the old name resonated with people.
                        </p>,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : () =>
                        <div style = {window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}>
                          <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN3} vbx='800' vby='988' r='11'
                            hotspots={[
                              {x: '660', y: '35', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '650', y: '220', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                            ]}>
                          </HotspotImage>
                        </div>
                      },
                      {
                        description :
                        <p>
                          <p className = {classNames(slideStyles.slidePara_16)}>
                            After the Partition, the Halqa turned its attention towards the role of literature in the newly created state. The Halqa devoted a lot of time pondering over the promotion and development of Urdu, the new national language. With this consideration, the Halqa aimed to set up its branches in other towns and cities, of which Karachi was one. The export of literary material from Lahore to Karachi served to maintain the centrality of Lahore in the literary milieu of Pakistan.
                          </p>
                          <p>
                            <i>Urdu ka mustaqbil</i> (The future of Urdu): After 1947, the literary focus of the Halqa Arbab-e-Zouq was towards the promotion of a new national literature. This archive quotes an instruction for the Halqa’s branch in Peshawar for their next publication to focus on the “future”.
                          </p>
                        </p>
                        ,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : ()=>
                        <div style = {window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}>
                          <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN4} vbx='800' vby='988' r='11'
                            hotspots={[
                              {x: '700', y: '810', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '470', y: '39', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                            ]}>
                          </HotspotImage>
                        </div>
                      },
                      {
                        description : <p className = {classNames(slideStyles.slidePara_16)}>
                          A notice dismissing Intizar Hussain from the Halqa (Proceedings of the Halqa Arbab-e-Zouq, 16 June 1954).
                        </p>,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : () =>
                        <div style = {window.innerHeight > 675 ? {width: '80%', marginLeft: '10%'} : {width: '70%', marginLeft: '15%'}}>
                          <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN5} vbx='800' vby='932' r='11'
                            hotspots={[
                              {x: '675', y: '350', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '650', y: '150', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true},
                              {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                            ]}>
                          </HotspotImage>
                        </div>
                      }]
                    }
                    />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter3slide2",
        next : "chapter4",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      }
    }
  },
  "chapter4" : {
    name : "Chapter 4: Miraji",
    slides : {
      "chapter4" : {
        component : (
          <Slide bgImage={Chapter4Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <ChapterTitle
                      inverted
                      chapter_number="4"
                      chapter_title="Miraji"
                      subtitle = "میراجی"
                      urduSub
                      addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                      images={[
                        {image: MeerajiTitle, id: chTStyles.MeerajiTitle, shift: 15},
                      ]}
                    />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(82,22,22,0) 0%,rgba(92,17,17,0.48) 48%,rgba(101,11,11,0.97) 97%,rgba(110, 2, 2, 1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter3slide3",
        next : "chapter4slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter4slide1" : {
        slideName : "Miraji’s Rise from Mozang, Lahore",
        component : (
          <Slide bgImage={Slide9Back} absoluteImage={{src: MeerajiPort, id: imageStyles.absoluteMeerajiPort}}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={layoutStyles.layout_100}>
                        <SlideHeading inverted noPadding title="Miraji’s Rise from Mozang, Lahore" desc="Miraji was one of the central literary figures leading and influencing the Halqa Arbab-e-Zauq. Born in Mozang, Miraji was a larger than life and enigmatic figure surrounded by mystery. His life in Mozang’s “tightly scripted lanes” seemed to impact his image and persona; he appeared as a wild, and even an insane vagabond, growing up in colonial Lahore’s narrow streets, dirt and disease. A “walking, wandering corpse”. Miraji thus stood out in the crowded and animated cityscape of Mozang - aloof, struggling with and contemplating on notions of love, sexuality, desire, intimacy and himself, within a poetic and yet ugly world. Yet, Miraji’s persona is remembered to also be generous, respectful, and grateful - with a deep understanding of sharing literary work, appreciating aesthetic, analyzing and critiquing literature to push its boundaries beyond the conventional, and a journey of self-discovery."/>
                      </div>
                    </Layout>
                  </div>
                </div>
            )}}
          </Slide>
        ),
        prev : "chapter4",
        next : "chapter4slide2",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter4slide2" : {
        slideName : "Miraji shaping Lahore’s Literary Culture",
        component : (
          <Slide bgImage={Slide10Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Miraji shaping Lahore’s Literary Culture"/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev)}><MdChevronRight/></div>
                  </div>

                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div>
                              <p className={classNames(slideStyles.slidePara)}>
                                Miraji’s life in Lahore built the foundations of his poetic worldview and literary style and position. It is here that he discovered his literary passion while attending Mozang High School, writing with the pen name of <i>Sahar</i>. His brother introduced him to aspiring literary figures and Miraji began to learn how to interact and make his place in literary circles. Published at an early age, Miraji quietly made his mark within Lahore’s literary tradition, sharing his work and presence in various literary centers and coffee houses of the city. During his journey of becoming the nucleus of literary activity in Lahore, he became the Poetry Editor at <i>Adabi Dunya</i> (Literary World), the Lahore magazine of letters, gaining a profound platform for the publishing of his poems, essays and critiques. With his writing and voice becoming significant for Lahore’s literary culture, the wild, vagabond, “shipwrecked” Miraji eventually contributed to the Halqa in ways that changed Urdu literary experience. Thus, the city made the poet who then influenced the city and its culture in turn.
                              </p>
                            </div>
                          </div>
                          <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div id={imageStyles.MeerajiNazm} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                              <img src={MeerajiNazm} alt="Miraji - Is Nazm mein" className={classNames(imageStyles.hover_effect)}/>
                            </div>
                          </div>
                        </Layout>
                        <div ref={props.addParallaxAndFadeRef(7)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                          <div id={imageStyles.MeerajiNazmein} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="Miraji ki nazmein" className={classNames(imageStyles.hover_effect)} src={MeerajiNazmein}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div id={imageStyles.Chirag_Miraji} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="Chiragh Hasan Hasrat and Miraji" className={classNames(imageStyles.hover_effect)} src={Chirag_Miraji}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                            <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1", 3]} linkMessage="" linkSource="" image={MeerajiVideo} imageStyle={{width: '85%', alignSelf: 'center'}}/>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.MirajiDeath} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="Miraji's Death News" className={classNames(imageStyles.hover_effect)} src={MirajiDeath}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p>
                          Title cover of Miraji’s first edition of <i>Iss Nazam Mein</i> published from Delhi. Despite the “madness”, “obscenity” and “abnormality”, Miraji’s writings, voice and mind gradually made a significant place for itself in Lahore’s literary circles and experience, setting the foundations for the Halqa Arbab e Zauq in Lahore.
                        </p>,
                        title : "",
                        source : "DAWN",
                        render : ()=> <img alt="Miraji - Is Nazm mein" src={MeerajiNazm} style={window.innerHeight > 675 ? {width: '65%', marginLeft: '17.5%'} : {width: '58%', marginLeft: '21%'}}></img>,
                      },
                      {
                        description : "Miraji's Poems",
                        title : "",
                        source : "DAWN",
                        render : ()=> <img alt="Miraji ki nazmein" src={MeerajiNazmein} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%'}}></img>,
                      },
                      {
                        description : "Miraji photographed with Chiragh Hasan Hasrat",
                        title : "",
                        source : "Flickr",
                        render : ()=> <img alt="Chiragh Hasan Hasrat and Miraji" src={Chirag_Miraji} style={{width: '75%', marginLeft: '12.5%'}}></img>,
                      },
                      {
                        description : "Hussam Badi reads 'Portrait of Miraji' - Aijaz Ahmad's impression of Miraji",
                        title : "",
                        source : "Zer Zabar Pesh",
                        render : ()=> <VideoFrame link="https://www.youtube.com/embed/BqdnyxrGVdo"/>,
                      },
                      {
                        description : <p>
                          A newspaper clipping of Miraji’s early death at age 37, which brought an end to a literary era where his writing, persona and unconventionality challenged notions of normality within literary circles. Miraji was built by Lahore - fragments of childhood memories and places shaped him as he came to be known as the abnormal, insane and yet a gifted literary figure.
                        </p>,
                        title : "",
                        source : "Flickr",
                        render : ()=> <img alt="Miraji's Death News" src={MirajiDeath} style={{width: '50%', marginLeft: '25%'}}></img>,
                      }
                      ]
                    }
                  />
                </div>
            )}}
          </Slide>
        ),
        prev : "chapter4slide1",
        next : "chapter4slide3",
        menuInverted : false
      },
      "chapter4slide3" : {
        slideName : "Miraji’s Mind: Love and the City",
        component : (
          <Slide bgImage={Slide9Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading inverted title="Miraji’s Mind: Love and the City"/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <Layout fixed_width layoutClassName="layout_flexed">
                          <div ref={props.addParallaxAndFadeRef(8)}  className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <p className={classNames(slideStyles.slidePara, slideStyles.white)}>Various locations and experiences in Lahore create fragmented memories that built Miraji in the 1920’s and 30’s - his thoughts, feelings, poetic expressions and even his name and identity. Here he met Bashir Chand, his first love, to whom he wrote letters and contemplated on the meaning of desire, love and what they meant for him and the figure he was supposed to be. However, the most profound, permanent and ever-lasting experience was that of stumbling upon and falling in love with Mira Sen, the daughter of a known Professor in Lahore. Mira Sen’s love made F.C College (where she studied), YMCA (Young Men’s Christian Association- where he tried to talk to her), Kinnaird College (where he used to gather with his company to observe Mira with her friends) and Lek Road (where she lived) life changing locations for Miraji. Although Mira never spoke to him, the poet gave himself the name Miraji, attaching himself to his unrequited love and desire, and bringing those themes to the forefront in his writing changing the entire course of the city’s literary experience.</p>
                          </div>
                          <div ref={props.addParallaxAndFadeRef(20)} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                            <div id={imageStyles.MeerajiNazm} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                              <img src={MeerajiGeet} alt="'Geet hi Geet' by Miraji" className={classNames(imageStyles.hover_effect)}/>
                            </div>
                          </div>
                        </Layout>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25)}>
                          <div id={imageStyles.MeerajiPoem} className={classNames(imageStyles.Lit_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="'Jawani ke ghao' by Miraji" className={classNames(imageStyles.hover_effect)} src={MeerajiPoem}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : <p>Miraji's book <i>Geet hi Geet</i></p>,
                          title : "",
                          source : "DAWN",
                          render : ()=> <img alt="'Geet hi Geet' by Miraji" src={MeerajiGeet} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '55%', marginLeft: '22.5%'}}></img>,
                        },
                        {
                          description : <p>Miraji's Poem, <i>Jawani ke ghao</i></p>,
                          title : "",
                          source : "DAWN",
                          render : ()=> <img alt="'Jawani ke ghao' by Miraji" src={MeerajiPoem} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '45%', marginLeft: '27.5%'}}></img>,
                        }]
                      }
                    />
                  </div>
                </div>
            )}}
          </Slide>
        ),
        prev : "chapter4slide2",
        next : "chapter4slide4",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter4slide4" : {
        slideName : "Miraji, the Halqa and Demonic Desire and Femininity",
        component : (
          <Slide bgImage={Slide10Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Miraji, the Halqa and Demonic Desire and Femininity"/>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(8)}  className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <p className={classNames(slideStyles.slidePara)}>Miraji brought together and tangled themes of differing kinds of desire, love, sexuality, nationalism, modernity and debates on masculinity and femininity. He lived while opposing colonial and patriarchal contexts of nationalism represented by masculinity. Seen as self- absorbed and possibly “demonic”, Miraji was associated with a language and imagery reserved for femininity - a senseless experience of hysteria, nymphomania, eroticism and sentimentality. He was not the “stoic” or “chivalrous” male nationalist - his voice addressed himself as just “I” and yet spoke in harmony with differing nationalist voices from the right and the left, both. Miraji thus lived in fluidity, perhaps even became that fluidity - of thought, emotion, social position and personal discovery. Thus, when Miraji entered the Halqa in 1940, he brought his style of close literary reading, rigorous analysis and appreciation alongside critique, to widen the literary scope and experience of the city and its literary figures. With the emergence of the Progressive Writers’ Association (Urdu Chapter), Miraji was systematically excluded and isolated from the Pan-Indian literary experience for his unconventional writings, persona and breaches of the PWA literary canon.</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(20)} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.MeerajiNazm} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                          <img src={MeerajiGeeta} alt="Geeta Patel's book on Miraji" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p><i>Lyrical Movements, Historical Hauntings - On Gender, Colonialism, and Desire in Miraji’s Urdu Poetry</i> by Geeta Patel</p>,
                        title : "",
                        source : "Stanford University Press",
                        render : ()=> <img alt="Geeta Patel's book on Miraji" src={MeerajiGeeta} style={window.innerHeight > 675 ? {width: '70%', marginLeft: '15%'} : {width: '60%', marginLeft: '20%', marginTop: '15px'}}></img>,
                      }]
                    }
                  />
                </div>
            )}}
          </Slide>
        ),
        prev : "chapter4slide3",
        next : "credits",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
    }
  },
  "credits" : {
    name : "Lahore's Literary Landscape",
    slides : {
      "credits" : {
        component : (
          <Slide bgImage={ProjectCreditsBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                  <div className={slideStyles.slideContent}>
                    <ProjectCredits
                      disclaimer=<span>These projects are based on research conducted by students for the course <i>Walking in the City: Mapping Everyday Life in Lahore.</i></span>
                      projectName="Lahore's Literary Landscape "
                      studentNames="Amen Imran, Fatima Afzal, Hassan Aziz, Mahnoor Kazmi, Rana Muhammad Haris Khan and Zohra Aslam"
                      supervisor={{name: 'Dr Ali Usman Qasmi', desig: 'Associate Professor (History), Department of Humanities and Social Sciences, LUMS'}}
                    />
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter4slide4",
        next : "credits",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: '',
        hideVerticalNav: true
      },
    }
  },
}

function topoSortSlides(slides){
  const visitedSet = {};
  const orderArr = [];
  const allSlidesMap = {};

  for(let i in slides){
    for(let j in slides[i].slides){
      allSlidesMap[j] = slides[i].slides[j];
    }
  }

  Object.keys(allSlidesMap).forEach((s)=>{
    topoSortNode(s, allSlidesMap, orderArr, visitedSet)
  })
  return orderArr.reverse().reduce((acc,d,i)=>{
    acc[d] = i;
    return acc;
  },{});
}

function topoSortNode(nodename,nodes, orderArr, visitedSet){
  if(nodename === null || visitedSet[nodename]){
    return orderArr;
  }

  visitedSet[nodename] = true;
  topoSortNode(nodes[nodename].next, nodes, orderArr, visitedSet);
  orderArr.push(nodename);

  return orderArr;
}

const slideOrder = topoSortSlides(slideMap)

const chapterArr = ["chapter1","chapter2","chapter3","chapter4"];

const mobileSlideMap = {
  "home" : {
    name: "Project Home",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <ProjectTitleMobile
                image={ProjectTitleBack}
                title="Lahore’s Literary Landscape"
                to="chapter1"
                description="Exploring places, personalities and movements that shaped the literary culture of Lahore between the 1930s and 1970s"
              />
            )
          }
        }
      </MobileSlide>
    ),
    menuInverted: false,
  },
  "chapter1" : {
    name: "Chapter 1: Lahore - a literary center",
    component : (
      <MobileSlide>
        {(props) => {
          return (
            <div>
              <ChapterTitleMobile
                inverted
                image={Chapter1Title}
                chapter_number="1"
                chapter_title="Lahore - a literary center"
                subtitle = "لاہور، ایک ادبی مرکز"
                id={chTStyles.lhrLitCentMobile}
                images={[
                  {image: maulanaAzad1, id: chTStyles.maulanaAzad1}
                ]}
                gradient='linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'
              />
              {/* NEXT SECTION */}
              <MobileSectionTitle
                image={ch1Light}
                title="Origins of Urdu in Lahore"
                chapterNumber="CHAPTER 1: LAHORE - A LITERARY CENTER"
                note="Pictures in the chapter can be clicked for expanded view"
              />
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                <p className={mobileStyles.mobilePara}>
                  After annexing Punjab in the late 19th century, the British changed the official language of Punjab from Persian to Urdu. Punjabi - the most widely spoken language was not even considered as an option as it was described in derogatory terms in colonial documents as “rural patois”, a dialect not adequate to be set as the official language.
                </p>
                <p className={mobileStyles.mobilePara}>
                  To institute the teaching of Urdu in Punjab, the British encouraged a number of luminaries to migrate from North India to take up employment in Lahore. Muhammad Husain Azad migrated to Lahore in 1861 and joined the recently established Government College. He later joined the <i>Anjuman-i-Punjab</i>, started by Gottlieb W. Leitner, to promote Urdu literary practices.
                </p>
                <p className={mobileStyles.mobilePara}>
                  These two factors made Lahore an important center of Urdu literary culture. <i>Mushairas</i> were held regularly by the <i>Anjuman-e-Punjab</i> on the suggestion of Leitner. The emphasis was put on reforming Urdu poetry to adopt a more modern sensibility. The poets who came to Lahore, like Hali, were encouraged to ‘reform’ Urdu poetry by composing verses in the <i>nazam</i> format, as opposed to the <i>ghazal</i>.
                </p>
              </div>
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                <div className={mobileStyles.galleryChevrons_container}>
                  <div>
                    <p className={slideStyles.galleryTitle}>Gallery</p>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <div onClick={props.moveBackward('1')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                    <div onClick={props.moveForward('1')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                  </div>
                </div>
              </div>
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                <HorizontalScroll
                  scrollContainerRef={props.addScrollRef('1')}
                  xPos={props.xPos['1']}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["1",0])} alt="Shams-ul-Ulema, Maulana Muhammad Husain Azad was a pioneer of Urdu literature in Lahore" src={MaulanaAzad2}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["1",1])} alt="1880. Mohammad Husain Azad’s seminal work, Aab-e-Hayat (water of life) on the history of Urdu language published. Azad was a part of the Urdu writers who migrated from Delhi to Lahore after the War of 1857 and initiated the beginnings of an Urdu literary culture of Lahore." src={AabeHayatJPG}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["1",2])} alt="A linguist and educator, Gottlieb W. Leitner was appointed the Principal of Government College Lahore in 1864. While at Government College. Leitner set up the Anjuman-i-Ishaat-i-Mutalib-i-Mufida-i-Punjab, ‘The society for the diffusion of useful knowledge’, whose prime objective was the diffusion of literary and scientific knowledge in vernacular languages. The photo shows the title page of Leitner's book 'The Languages and races of Dardistan'. Dardistan was a term coined by Leitner for Northern Indian regions including Kashmir" src={dardistan}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["1",3])} alt="The Urdu poet Maulana Altaf Hussain Hali migrated to Lahore in 1869 to work at the Government Book Depot and stayed till 1874. He used to partake in the mushairas organized by the Anjuman-i-Punjab" src={Hali}/>
                    </div>
                </HorizontalScroll>
              </div>
              {/* NEXT SECTION */}
              <MobileSectionTitle
                image={ch1Dark}
                inverted
                title="The Mall: a literary hub"
                chapterNumber="CHAPTER 1: LAHORE - A LITERARY CENTER"
                note="Pictures in the chapter can be clicked for expanded view"
              />
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                <p className={mobileStyles.mobilePara}>
                  The development of Lahore as a newly created centre for Urdu literary movements after the Partition is often associated with the migration of prominent Muslim literary figures to Lahore from North India, especially East Punjab. Many of the migrated writers and poets found the Upper Mall area of the city to be a lot like Delhi, something they were familiar with.
                </p>
                <p className={mobileStyles.mobilePara}>
                  A lot of these literature scholars established affiliations with educational institutions such as the Punjab University, Government College, Muslim Anglo-Oriental College, and the Dayal Singh College. All of these were in close proximity to each other on the Mall Road. Thus, the Mall soon became a hub for literary scholars and consequently became the centre for literary movements in the city.
                </p>
              </div>
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                <div className={mobileStyles.galleryChevrons_container}>
                  <div>
                    <p className={slideStyles.galleryTitle}>Gallery</p>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <div onClick={props.moveBackward('2')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                    <div onClick={props.moveForward('2')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                  </div>
                </div>
              </div>
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                <HorizontalScroll
                  scrollContainerRef={props.addScrollRef('2')}
                  xPos={props.xPos['2']}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["2",0])} alt="Street View of the Mall" src={Mall}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["2",1])} alt="Anarkali Bazaar" src={Anarkali}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["2",2])} alt="Bhaati Gate" src={Bhaati}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["2",3])} alt="Government College" src={GC}/>
                    </div>
                </HorizontalScroll>
              </div>
              {/* NEXT SECTION */}
              <MobileSectionTitle
                image={ch1Light}
                title="Pak Tea House"
                chapterNumber="CHAPTER 1: LAHORE - A LITERARY CENTER"
                note="Pictures in the chapter can be clicked for expanded view"
              />
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                <p className={mobileStyles.mobilePara}>
                  The site of the famous Pak Tea House was initially home to the Coffee House, later the India Tea house. After 1947, it was given to a refugee named Siraj who renamed it as the Pak Tea House. The initial use of the space as the Coffee House was sponsored by the Coffee Board set up by the Indian government in the 1930s. Coincidentally, the Coffee House had been set up at a time when Communist ideas had captured the imagination of a new generation of Indian youth, intellectuals and political workers. Owing to this, the space became the meeting place for the Leftists. The place was central to Lahore’s literary scene as well, especially after it became the meeting place of the Progressive Writers’ Association. It was also frequented by literary figures who did not have a direct link with the Progressive Writers’ Movement.
                </p>
              </div>
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                <div className={mobileStyles.mobile_layout_50}>
                  <img id={imageStyles.PTHMapMobile} className={mobileStyles.shadowImage} src={PTHMap} alt="Pak Tea House, a central location to all literary hubs around the Mall" onClick={()=> props.setDisplayedOverlay(["4",0])}/>
                </div>
              </div>
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                <div className={mobileStyles.galleryChevrons_container}>
                  <div>
                    <p className={slideStyles.galleryTitle}>Gallery</p>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <div onClick={props.moveBackward('3')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                    <div onClick={props.moveForward('3')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                  </div>
                </div>
              </div>
              <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                <HorizontalScroll
                  scrollContainerRef={props.addScrollRef('3')}
                  xPos={props.xPos['3']}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",0])} alt="A group of patrons at the Pak Tea House. Famous revolutionary poet, Habib Jalib is also photographed (seated third from right)" src={PakT1}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",1])} alt="A poet recites as Faiz Ahmad Faiz (seated second from right) and others listen" src={PakT2}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",2])} alt="Facade of the famous Pak Tea House" src={PakT3}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                      <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",3])} alt="A group of patrons at the Pak Tea House" src={PakT4}/>
                    </div>
                </HorizontalScroll>
              </div>
              <NextChapterTitle
                inverted
                image={Chapter2Title}
                title="The Progressive Writer's Association"
                nextChapter="chapter2"
                prevChapter="home"
              />
              <Overlay
                oId="1"
                displayedOverlay={props.displayedOverlay}
                closeOverlay={props.closeOverlay}
                setDisplayedOverlay={props.setDisplayedOverlay}
                slides={
                  [{
                    description : <p><i>Shams-ul-Ulema</i> Maulana Muhammad Husain Azad was a pioneer of Urdu literature in Lahore</p>,
                    source : "Flickr",

                    render : ()=> <img alt="" src={MaulanaAzad2} id = {overlay_styles.MaulanaAzad2}></img>,
                  },
                  {
                    description : <p>Mohammad Husain Azad’s seminal work, <i>Aab-e-Hayat</i> (water of life), on the history of Urdu language published in 1880. Azad was an important literary figure who migrated from Delhi to Lahore after the War of 1857 and initiated the beginnings of an Urdu literary culture in Lahore.</p>,
                    source : "Rekhta",
                    render : ()=> <img alt="1880. Mohammad Husain Azad’s seminal work, Aab-e-Hayat (water of life) on the history of Urdu language published. Azad was a part of the Urdu writers who migrated from Delhi to Lahore after the War of 1857 and initiated the beginnings of an Urdu literary culture of Lahore." src={AabeHayatJPG} id = {overlay_styles.AabeHayatJPG}></img>,
                  },
                  {
                    description :
                    <p>
                      <p>
                        A linguist and educator, Gottlieb W. Leitner was appointed the Principal of Government College Lahore in 1864. While at the Government College, Lietner set up the <i>Anjuman-i-Ishat-i-Matalib-i-Mufida-i-Punjab</i> - ‘The society for the diffusion of useful knowledge in Punjab’, whose prime objective was the propagation of literary and scientific knowledge in vernacular languages. The photo shows the title page of Leitner's book - <i>The Languages and Races of Dardistan</i>.
                      </p>
                      <p>Source : https://www.lotsearch.net/</p>
                    </p>,
                    source : "",
                    render : ()=> <img alt="A linguist and educator, Gottlieb W. Leitner was appointed the Principal of Government College Lahore in 1864. While at Government College. LietnerLeitner set up the Anjuman-i-Ishaat-i-Mutalib-i-Mufida-i-Punjab, ‘The society for the diffusion of useful knowledge’, whose prime objective was the diffusion of literary and scientific knowledge in vernacular languages. The photo shows title page of Leitner's book 'The Languages and races of Dardistan'. Dardistan was a term coined by Leitner for Norther Indian regions including Kashmir" src={dardistan} id = {overlay_styles.dardistan}></img>,
                  },
                  {
                    description : <p>The Urdu poet Maulana Altaf Hussain Hali migrated to Lahore in 1869 to work at the Government Book Depot and stayed till 1874. He used to partake in the mushairas organized by the <i>Anjuman-i-Punjab</i></p>,
                    source : "Wikipedia",
                    render : ()=> <img alt="The Urdu poet Maulana Altaf Hussain Hali migrated to Lahore in 1869 to work at the Government Book Depot and stayed till 1874. He used to partake in the mushairas organized by the Anjuman-i-Punjab" src={Hali} id = {overlay_styles.Hali}></img>,
                  }
                  ]
                }
              />
              <Overlay
                oId="2"
                displayedOverlay={props.displayedOverlay}
                closeOverlay={props.closeOverlay}
                setDisplayedOverlay={props.setDisplayedOverlay}
                slides={
                  [{
                    description : <p>
                      Most of the literary scholars that moved into the city after the Partition had settled in the posh areas of the Upper Mall, along with such middle-class localities as Krishan Nagar, Lakshmi Chowk, and Bhatti Gate. Cafes and restaurants on the Mall also attracted literary scholars to relax, debate, and exchange ideas, essays, and poetry.  The Pak Tea House, Nagina Bakery, Arab Hotel, and the extremely popular Cafe Orient were a few of the places frequented by literary figures
                    </p>,
                    source : "Lahore City History, http://city-history.com/",

                    render : ()=> <img alt="Street View of the Mall" src={Mall} id = {overlay_styles.Mall}></img>,
                  },
                  {
                    description : <p>
                      The Anarkali Bazar, c.1947. The Anarkali Bazar was a central area surrounded by places of education such as the Government College, Punjab University, Islamia College, and Dayal Singh College. As a result of this, its small coffee shops and cafes were often frequented by major personalities in Lahore’s literary scene.
                    </p>,
                    source : "Lahore City History, http://city-history.com/",
                    render : ()=> <img alt="Anarkali" src={Anarkali} id = {overlay_styles.Anarkali}></img>,
                  },
                  {
                    description : <p>
                      The Bhatti gate was also an important location as it was in close proximity to the Government College and Islamia College. It was known for its small Kebab shops, which were often frequented by important literary personalities.
                    </p>,
                    source : "",
                    render : ()=> <img alt="Bhaati gate" src={Bhaati} id = {overlay_styles.Bhaati}></img>,
                  },
                  {
                    description : <p>
                      The Government College served as a host to a lot of literary meetings. A number of <i>mushairas</i> were also held in the college. Poets such as Nafees Khalili, Abid Ali Abid, and Abdul Majeed Bhatti would often present their work at such events held at the College.
                    </p>,
                    source : "Lahore City History, http://city-history.com/",
                    render : ()=> <img alt="Government College" src={GC} id = {overlay_styles.GC}></img>,
                  }
                  ]
                }
              />
              <Overlay
                oId="3"
                displayedOverlay={props.displayedOverlay}
                closeOverlay={props.closeOverlay}
                setDisplayedOverlay={props.setDisplayedOverlay}
                slides={
                  [{
                    description : "A group of patrons at the Pak Tea House. Famous revolutionary poet, Habib Jalib is also photographed (seated third from right)",
                    source : "DAWN",
                    render : ()=> <img alt="A group of patrons at the Pak Tea House. Famous revolutionary poet, Habib Jalib is also photographed (seated third from right)" src={PakT1} id = {overlay_styles.PakT1}></img>,
                  },
                  {
                    description : "A poet recites as Faiz Ahmad Faiz (seated second from right) and others listen",
                    source : "DAWN",
                    render : ()=> <img alt="A poet recites as Faiz Ahmad Faiz (seated second from right) and others listen" src={PakT2} id = {overlay_styles.PakT2}></img>,
                  },
                  {
                    description : "Facade of the famous, Pak Tea House",
                    source : "DAWN",
                    render : ()=> <img alt="Facade of the famous, Pak Tea House" src={PakT3} id = {overlay_styles.PakT3}></img>,
                  },
                  {
                    description : "A group of patrons at the Pak Tea House. Intizar Hussain, a prominent member of the Halqa Arbab-e-Zouq, is seated (second from right) on the lower table. Poet Nasir Kazmi accompanies on the same table (left)",
                    source : "DAWN",
                    render : ()=> <img alt="A group of patrons at the Pak Tea House" src={PakT4} id = {overlay_styles.PakT4}></img>,
                  }
                  ]
                }
              />
              <Overlay
                oId="4"
                displayedOverlay={props.displayedOverlay}
                closeOverlay={props.closeOverlay}
                setDisplayedOverlay={props.setDisplayedOverlay}
                slides={
                  [{
                    description : "The map shows the Government College, Punjab University, and Dayal Singh College. Right in the middle, on the Robert road, stands the famous Pak Tea House next to the YMCA hall, where the Progressive Writers’ Movement and the Halqa-e-Arbab-e-Zauq would often hold their meetings. It also hosted the All Pakistan Progressive Writers’ Association’s first ever meeting.",
                    source : "",

                    render : ()=> <img alt="Pak Tea House, a central location to all literary hubs around the Mall" src={PTHMap} id = {overlay_styles.PTHMap}></img>,
                  }
                  ]
                }
              />
            </div>
          )}}
      </MobileSlide>
    ),
    menuInverted : true,
  },
  "chapter2": {
    name: "Chapter 2: The Progressive Writer's Association",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div>
                <ChapterTitleMobile
                  inverted
                  image={Chapter2Title}
                  chapter_number="2"
                  chapter_title="The Progressive Writers' Association"
                  subtitle = "انجمن ترقی پسند مصنفین"
                  id={chTStyles.PWAMobile}
                  images={[
                    {image: FaizSajjad, id: chTStyles.absoluteFaizSajjad}
                  ]}
                  gradient='linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'
                />
                <MobileSectionTitle
                  image={ch2Light}
                  title="Progressive Writers' Association (PWA) in Lahore"
                  chapterNumber="CHAPTER 2: PROGRESSIVE WRITERS' ASSOCIATION"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>The Progressive Writers’ Movement was extremely prominent among the literary movements of Lahore. The Progressive Writers’ Movement operated in a doctrinal triangle whose three nodes were pragmatism, Marxism, and a western orientation. The group was left-oriented, and sought to inspire people through their writings advocating equality among all humans and attacking social injustice in the society. Its members included notable literary personalities such as Faiz Ahmed Faiz, Sibt-e-Hasan, Habib Jalib, Ahmed Faraz, Ali Sardar Jafri, Sadat Hasan Manto, Ahmed Nadeem Qasmi, Hameed Akhtar and Sahir Ludhianvi . The association had its own publication as well - a magazine by the name of <i>Nizam</i>. Intizar Hussain - though he did not share leftist leanings - served as the editor of <i>Nizam</i> in its early years and writes fondly of the discourse that was prevalent in the publication.</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.PWALogMobile} src={PWALogo} alt="PWA's logo"/>
                  </div>
                </div>
                <MobileSectionTitle
                  image={ch2Dark}
                  inverted
                  title="Formation of PWA"
                  subtitle=<span><i>Angaray</i> causes a literary upheaval</span>
                  year=<span><i>Angaray</i> causes a literary upheaval</span>
                  chapterNumber="CHAPTER 2: PROGRESSIVE WRITERS' ASSOCIATION"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>
                    The foundations of the PWA were set by the publication of <i>Angaray</i>, an anthology of short stories by Sajjad Zaheer, Ahmed Ali, Dr Rashid Jahan and Mahmud-uz-Zafar in 1932-33. Deemed to have breached socio-religious norms around marriage and sexuality, <i>Angaray</i> was described as “nakedly vulgar”, pulled off shelves and even banned by the Uttar Pradesh Government. <i>Angaray</i> opened the much-feared debate on literary content, boundaries and authority to determine what can and cannot be discussed in society. This paved the way for the PWA as a space for such debates. With the growth of the PWA after its creation by these progressive writers in 1939, the canon was captured and shaped by it, beginning a new phase in the literary culture of Lahore and colonial India.
                  </p>
                  <p className={mobileStyles.mobilePara}>
                    Sajjad Zaheer and his contemporaries paved the path for and created the PWA, with its first manifesto appearing in London in 1936. PWA’s inaugural meeting was held in Lucknow in June 1939, where notable literary figures joined the movement and Munshi Premchand declared the PWA’s mission to enlighten and bring about “new experience”.
                  </p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward('1')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward('1')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef('1')}
                    xPos={props.xPos['1']}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} id={imageStyles.Ang1Mobile} onClick={()=> props.setDisplayedOverlay(["1",0])} alt="Title page of the book Angaray" src={AngarayTitle}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} id={imageStyles.Ang2Mobile} onClick={()=> props.setDisplayedOverlay(["1",1])} alt="Authors of Angaarey, Rashid Jahan (second from right) and Mahmuduzzafar (extreme left)"  src={AngarayTeam}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(imageStyles.full_gallery)} style={{cursor: 'pointer'}} id={imageStyles.Ang3Mobile} onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Police Notice about 'Angaray', published in the U.P Gazette 1933"  src={AngarayEng}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33_portrait)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} id={imageStyles.Ang4Mobile} onClick={()=> props.setDisplayedOverlay(["1",3])} alt="Sajjad Zaheer, the leading force behind the Progressive Writers' Association"  src={SajjadZah}/>
                      </div>
                  </HorizontalScroll>
                </div>
                <MobileSectionTitle
                  image={ch2Light}
                  title="Political Debates"
                  chapterNumber="CHAPTER 2: PROGRESSIVE WRITERS' ASSOCIATION"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>
                    Intizar Hussain writes that the topics of discussion in 1947-49 were often centred around the politics of Partition. In fact, it can be said that one of the reasons that the literary scholars of Lahore were so active at that time was that there was a lot to talk about. The socio-political changes that the world was going through following the defeat of the Third Reich in World War II had given writers and thinkers a plethora of topics and ideas to discuss and debate. Sentiments were high and a lot of thinkers and scholars - especially those with a progressive outlook - expressed reservations about the trajectory taken by the newly established state of Pakistan. However, there were also a lot of writers that called for loyalty to the newly created state of Pakistan and critiqued the writers speaking against it. One of them was the well renowned critic and intellectual, Professor Muhammad Hassan Askari. This conflict of ideas generated a vibrant literary and intellectual culture.
                  </p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.PWA_PolMob} src={PWA_Politics} className={mobileStyles.shadowImage} alt="Muhammad Hasan Askari, Saleem Ahmad and Intizar Hussain" onClick={()=> props.setDisplayedOverlay(["2",0])}/>
                    <p id={imageStyles.PWA_PolMob} className={mobileStyles.mobileImageDesc}>Muhammad Hasan Askari, Saleem Ahmad and Intizar Hussain</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.PWAPolMob} src={PWAPolitics} className={mobileStyles.shadowImage} alt="Sibt-e-Hasan, Faiz Ahmed Faiz, Hameed Akhtar and Ahmed Nadeem Qasmi" onClick={()=> props.setDisplayedOverlay(["2",1])}/>
                    <p id={imageStyles.PWAPolMob} className={mobileStyles.mobileImageDesc}>Sibt-e-Hasan, Faiz Ahmed Faiz, Hameed Akhtar and Ahmed Nadeem Qasmi</p>
                  </div>
                </div>
                <MobileSectionTitle
                  image={ch2Dark}
                  inverted
                  title="Philosophy"
                  chapterNumber="CHAPTER 2: PROGRESSIVE WRITERS' ASSOCIATION"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>
                    The PWA was a pan-Indian organization with links to various foreign and political groups espousing similar ideas about life, literature, politics and revolution. The PWA began as just another “self-selecting literary club”, banding together poets and writers who endorsed progress, a loose term with a large range of meanings. As the general literary context began incorporating political and social commentary in it, the PWA defined progress by attaching literature with social action. While PWA’s political associations were not pronounced initially, they became stark and reinforced the growing demarcations of literary stances.
                  </p>
                  <p className={mobileStyles.mobilePara}>
                    The PWA emphasized the importance of <i>sayasat</i> (political), <i>samaj</i> (society), <i>maqsad</i> (purpose) and <i>mahol</i> (ambiance) as key to literary production. It aimed at heralding social change by highlighting the injustices and bitter realities of life and bringing literature closer to the lives of the dispossessed. The PWA treated the past as the era of degeneration and the present as the opportunity to reform society through the power of literature.
                  </p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.PWA_MaulMob} src={PWA_MaulviAH} className={mobileStyles.shadowImage} alt="Members of the Progressive Writers' Association" onClick={()=> props.setDisplayedOverlay(["3",0])}/>
                  </div>
                </div>

                <MobileSectionTitle
                  image={ch2Light}
                  title="Personalities"
                  chapterNumber="CHAPTER 2: PROGRESSIVE WRITERS' ASSOCIATION"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div style={{flexWrap: 'wrap'}} className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["4",0])} id={imageStyles.SZGMobile} src={SajjadZaheerGall} alt="Sajjad Zaheer" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Sajjad Zaheer</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["4",1])} id={imageStyles.FaizStampMob} src={FaizStamp} alt="Faiz Ahmad Faiz"/>
                    <p className={mobileStyles.mobileImageDesc}>Faiz Ahmad Faiz</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["4",2])} id={imageStyles.HAMobile} src={HasanAskari} alt="Hasan Askari" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Hasan Askari</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["4",3])} id={imageStyles.SHMobile} src={SibteHasan} alt="Sibt-e-Hasan" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Sibt-e-Hasan</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["4",4])} id={imageStyles.AMMobile} src={AbdulMalik} alt="Abdullah Malik" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Abdullah Malik</p>
                  </div>
                </div>

                <MobileSectionTitle
                  image={ch2Dark}
                  inverted
                  title="Pictures and letters"
                  chapterNumber="CHAPTER 2: PROGRESSIVE WRITERS' ASSOCIATION"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                  <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                    <div className={mobileStyles.galleryChevrons_container}>
                      <div>
                        <p className={slideStyles.galleryTitle}>Gallery</p>
                      </div>
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <div onClick={props.moveBackward('2')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                        <div onClick={props.moveForward('2')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                      </div>
                    </div>
                  </div>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef('2')}
                    xPos={props.xPos['2']}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)}onClick={()=> props.setDisplayedOverlay(["5",0])} alt="Abdullah Malik and Faiz Ahmad Faiz" src={AM_Faiz}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)}onClick={()=> props.setDisplayedOverlay(["5",1])} alt="Abdullah Malik and Sajjad Zaheer"  src={AM_SZ}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",2])} alt="Eminent PWA members"  src={Faiz_AM}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",3])} alt="Sibt-e-Hasan, Dr M. Sarwar and Faiz Ahmed Faiz"  src={Faiz_SH}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",4])} alt="Sajjad Zaheer and Faiz Ahmed Faiz"  src={Faiz_SZ}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} id={imageStyles.Ang4Mobile} onClick={()=> props.setDisplayedOverlay(["5",5])} alt="Ali Sardar Jafri, Sibt-e-Hasan, Ismat Chughtai and Amna Majeed Malik"  src={SH_Ismet}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33_portrait)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",6])} alt="A letter from Faiz to Hameed Akhtar"  src={FaizLetter1}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33_portrait)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",7])} alt="A letter from Faiz to Hameed Akhtar"  src={FaizLetter2}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33_portrait)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",8])} alt="A letter from Faiz to Hameed Akhtar"  src={FaizLetter3}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33_portrait)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",9])} alt="A letter from Sibt-e-Hasan to Hameed Akhtar"  src={SHLetter1}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33_portrait)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",10])} alt="Roshnai, a book by Sajjad Zaheer"  src={Roshnai}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33_portrait)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["5",11])} alt="Sibt-e-Hasan's book 'Musa se Marx' tak"  src={MusaMarx}/>
                      </div>
                  </HorizontalScroll>
                </div>

                <MobileSectionTitle
                  image={ch2Light}
                  title="The Decline"
                  chapterNumber="CHAPTER 2: PROGRESSIVE WRITERS' ASSOCIATION"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className = {mobileStyles.mobilePara}>
                    Around 1949, the Progressive Writers’ Association took a different turn. In a meeting held at the flat of socialist intellectual and journalist, Mazhar Ali Khan, the Anjuman voted to bar any publication that did not conform to their socialist ideology. Consequently, writers such as Intizar Hussain and Hasan Askari were barred from writing and publishing anything in an Anjuman publication because of their opposition to the communist ideology. One of the reasons cited by Sibt-e-Hasan for his support for the decision was the successful communist revolution in China. The socialist intellectuals of Pakistan believed that by temporarily shutting down the voices of opposition in the wake of such a politically charged situation, they might be able to see a communist revolution in their own country as well. Sibt-e-Hasan later expressed regret at the decision in a personal letter addressed to Intizar Hussain.
                  </p>
                  <p className = {mobileStyles.mobilePara}>
                    Over time, this decree was withdrawn, but the damage had been done to the reputation of PWA. Also, with the arrest of major Anjuman members such as Faiz, Sajjad Zaheer, and many others following the failure of the alleged 1951 Rawalpindi Conspiracy, the association lost its vigor. The state used it as an excuse to clamp down on progressive organizations.
                  </p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.PWA_PolMob} src={PWA_Politics} className={mobileStyles.shadowImage} alt="Mohammad Hassan Askari and Intizar Hussain" onClick={()=> props.setDisplayedOverlay(["6",0])}/>
                    <p id={imageStyles.PWA_PolMob} className={mobileStyles.mobileImageDesc}>Mohammad Hassan Askari (left) and Intizar Hussain (right) were barred from publishing in any of the <i>Anjuman</i> publications</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.mantoMob} src={Manto} className={mobileStyles.shadowImage} alt="Saadat Hasan Manto" onClick={()=> props.setDisplayedOverlay(["6",1])}/>
                    <p id={imageStyles.mantoMob} className={mobileStyles.mobileImageDesc}>Manto, the famous short story writer, was also excluded from the association in 1949</p>
                  </div>
                </div>

                <NextChapterTitle
                  inverted
                  image={Chapter3Title}
                  title="Halqa Arbab-e-Zouq"
                  nextChapter="chapter3"
                  prevChapter="chapter1"
                />
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>Title page of the book <i>Angaray</i></p>,
                      source : "",

                      render : ()=> <img alt="Title page of the book Angaray" src={AngarayTitle} id={overlay_styles.AngarayTitle}></img>,
                    },
                    {
                      description : <p>
                        Authors of <i>Angaray</i>, Rashid Jahan (second from right) and Mahmud-uz-Zafar (extreme left)
                      </p>,
                      source : "Herald, DAWN",
                      render : ()=> <img alt="Authors of Angaray, Rashid Jahan (second from right) and Mahmud-uz-Zafar (extreme left)" src={AngarayTeam} id={overlay_styles.AngarayTeam}></img>,
                    },
                    {
                      description : <p>
                        Official excerpts and publications condemning <i>Angaray</i> and its circulation in society. The British colonial state, despite its secular pretense, struggled with such a direct re-introduction of the private into its controlled public, colonial space. <i>Angaray</i> not only challenged literary values and norms, socio-religious outlooks and the state, but an entire system of existence.
                      </p>,
                      source : "DAWN",
                      render : ()=> <img alt="Police Notice about 'Angaray', published in the U.P Gazette 1933" src={AngarayEng} id={overlay_styles.AngarayEng}></img>,
                    },
                    {
                      description : "Sajjad Zaheer, the leading force behind the Progressive Writers' Association",
                      source : "",
                      render : ()=> <img alt="Sajjad Zaheer, the leading force behind the Progressive Writers' Association" src={SajjadZah} id={overlay_styles.SajjadZah}></img>,
                    }
                    ]
                  }
                />
                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Pictured left to right: Muhammad Hasan Askari, Saleem Ahmad and Intizar Hussain. Muhammad Hasan Askari was known to be close friends with Intizar Hussain. He also contributed a lot to the political discourse in Lahore at the time by bringing up ideas of cultural Islamism and loyalty to the Pakistani state.",
                      title : "Sample Title",
                      source : "Flickr",
                      render : ()=> <img alt="Muhammad Hasan Askari, Saleem Ahmad and Intizar Hussain" src={PWA_Politics} id={overlay_styles.PWA_Politics}></img>,
                    },
                    {
                      description : "Pictured left to write: Sibt-e-Hasan, Faiz Ahmed Faiz, Hameed Akhtar and Ahmed Nadeem Qasmi. All four were prominent members of the Anjuman and would often frequent their meetings and engage in political debates about Communism and the newly created state of Pakistan.",
                      title : "Sample Title",
                      source : "Herald, DAWN",
                      render : ()=> <img alt="Sibt-e-Hasan, Faiz Ahmed Faiz, Hameed Akhtar and Ahmed Nadeem Qasmi" src={PWAPolitics} id={overlay_styles.PWAPolitics}></img>,
                    }
                    ]
                  }
                />
                <Overlay
                  oId="3"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <div>
                        <p>
                          Top picture: Left to right: Sibt-e-Hasan, Maulvi Abdul Haq, Mazhar Ali Khan, and Ahmed Nadeem Qasmi at a literary jalsa in the 1950s. Faiz and Sajjad Zaheer were in jail at this point.
                        </p>
                        <p>
                          Bottom picture: Sajjad Zaheer and Faiz Ahmad Faiz
                        </p>
                      </div>,
                      title : "Sample Title",
                      source : "DAWN/ Flickr",
                      render : ()=> <img alt="Members of the Progressive Writers' Association" src={PWA_MaulviAH} id={overlay_styles.PWA_MaulviAH}></img>,
                    }]
                  }
                />
                <Overlay
                  oId="4"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>
                        Sajjad Zaheer was one of the most influential members of the Progressive Writers’ Association. PWA’s first international conference was held in the Falletti’s Lahore in 1949. In this conference, a few Russian literary figures also participated. The Russian guests, while sitting in a room with Ahmed Nadeem Qasmi, Hajra Masroor, Khadija Mastoor, Safdar Mir, and Abdullah Malik, inquired about the founder of the Progressive Writers’ Movement. In response to this query, everyone in the room collectively replied with Sajjad Zaheer’s name. Zaheer also became the Secretary General of the Pakistan Communist Party. He lived in Lahore for a few years before travelling to Karachi to establish the presence of the Community Party there. While in Lahore, he lived near Anarkali Bazar on Dhani Ram road and later on Davis road and then Jail Road. After living in Karachi for a few years, he left for India.
                      </p>,
                      title : "Sample Title",
                      source : "",
                      render : ()=> <img alt="Sajjad Zaheer" src={SajjadZaheerGall} id={overlay_styles.SajjadZaheerGall}></img>,
                    },
                    {
                      description : <p>
                        One of the most prominent poets of Pakistan, Faiz became the flagbearer of revolutionary literature. His professional career included his time as a lecturer of English in MAO College in the late 1930s and chief editor of the Daily <i>Imroz</i>. As a poet of socialist leaning, Faiz did not fare too well with the Pakistani state and was jailed during the 1950s for his alleged role in a conspiracy to overthrow the government.
                      </p>,
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="Faiz's stamp" src={FaizStamp} id={overlay_styles.FaizStamp}></img>,
                    },
                    {
                      description : <div>
                        <p>In 1948, Hasan Askari wrote an essay that was published in the <i>Nizam</i> Magazine. He taunted the literary personalities of the time by associating them with Kipling’s <i>Bandar log</i> and accusing renowned and well-respected scholar Ali Sardar Jafri of frequenting the Café Orient solely because of the pretty Anglo-Indian hostess. The essay rejected the Progressive Writers Movement’s ideas about literature. It taunted the literati of Lahore and accused them of being disloyal to the state of Pakistan. From then on, Hasan Askari adopted an ‘Islamic approach’ in literature.</p>
                        <p className={overlay_styles.source}>Source: Flickr</p>
                      </div>,
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="Hasan Askari" src={HasanAskari} id={overlay_styles.HasanAskari}></img>,
                    },
                    {
                      description : <p>
                        Sibt-e-Hasan came to Lahore after the Partition and stayed in the Falletti’s hotel for a few days and left it as he found the hotel too sterilized and conventional for his taste . He entered the country on a fake name and passport. He remained the underground editor while Hameed Akhtar was the face of the newspaper. He resided in the Naqi building behind the Mall road, which became the epicenter of many literary activities in the city at that time.
                      </p>,
                      title : "Sample Title2",
                      source : "Goodreads",
                      render : ()=> <img alt="Sibt-e-Hasan" src={SibteHasan} id={overlay_styles.SibteHasan}></img>,
                    },{
                      description : <div>
                        <p>Abdullah Malik was a prominent member of the All India Communist Party, and took an active part in the political and social events in the country. He regularly attended the weekly literary circles that took place in various cities, where issues of social reform were discussed by political leaders and intellectuals alike. It was in Mumbai, in the year 1943, that Malik began to appear in literary circles as well as political rallies and meetings. He writes about how he was introduced to many literary figures through his friend, Sajjad Zaheer. On the 24th of May of the same year, the Progressive Writers Association had its fourth meeting, where many prominent figures such as Saghir Nizam, Krishan Chandar and others were present. It was at this conference that Malik came to realize that language had to be a central concern of any literary movement in India. He saw that each of these literary figures spoke and wrote in their own regional languages. He writes about how in these years, the attack on Indian culture was most viciously being carried out by the colonizer. It was in this context, he wrote, that it became a necessity to write and to produce works in the vernacular.</p>
                        <p className={overlay_styles.source}>Source: Flickr</p>
                      </div>,
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="Abdullah Malik" src={AbdulMalik} id={overlay_styles.AbdulMalik}></img>,
                    }]
                  }
                />
                <Overlay
                  oId="5"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Abdullah Malik (right) pictured with comrade and friend Faiz Ahmed Faiz.",
                      title : "Sample Title",
                      source : "The Friday Times",
                      render : ()=> <img alt="Abdullah Malik and Faiz Ahmad Faiz" src={AM_Faiz} id={overlay_styles.AM_Faiz}></img>,
                    },
                    {
                      description : "Abdullah Malik (second from the right) receiving prominent writer and Marxist Sajjad Zaheer (centre). ",
                      title : "Sample Title2",
                      source : "The Friday Times",
                      render : ()=> <img alt="Abdullah Malik and Sajjad Zaheer" src={AM_SZ} id={overlay_styles.AM_SZ}></img>,
                    },
                    {
                      description : "Mazhar Ali Khan (second from the left) with Faiz Ahmed Faiz next to him, laden with flowers. On the right stands Abdullah Malik.",
                      title : "Sample Title2",
                      source : "The Friday Times",
                      render : ()=> <img alt="Eminent PWA members" src={Faiz_AM} id={overlay_styles.Faiz_AM}></img>,
                    },
                    {
                      description : "Sibt-e-Hasan, Dr M. Sarwar and Faiz Ahmed Faiz",
                      title : "Sample Title2",
                      source : "The Friday Times",
                      render : ()=> <img alt="Sibt-e-Hasan, Dr M. Sarwar and Faiz Ahmed Faiz" src={Faiz_SH} id={overlay_styles.Faiz_SH}></img>,
                    },{
                      description : <p>
                        Sajjad Zaheer and Faiz Ahmed Faiz, significant members of the PWA. Sajjad Zaheer had financed the publication of <i>Angaray</i> himself, determined to change the course of literary traditions for Indian literary circles. A new wave of literary understanding emerged and gained momentum, as notions of progress, social disparities and reality were featured vehemently in literary works.
                      </p>,
                      title : "Sample Title2",
                      source : "Flickr",
                      render : ()=> <img alt="Sajjad Zaheer and Faiz Ahmed Faiz" src={Faiz_SZ} id={overlay_styles.Faiz_SZ}></img>,
                    },
                    {
                      description : "Ali Sardar Jafri seated on the right. Next to him is Sibt-e-Hasan, then Ismat Chughtai, and the second from the left is Amna Majeed Malik.",
                      title : "Sample Title2",
                      source : "DAWN",
                      render : ()=> <img alt="Ali Sardar Jafri, Sibt-e-Hasan, Ismat Chughtai and Amna Majeed Malik." src={SH_Ismet} id={overlay_styles.SH_Ismet}></img>,
                    },
                    {
                      description : "A letter from Faiz to Hameed Akhtar",
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="A letter from Faiz to Hameed Akhtar" src={FaizLetter1} id={overlay_styles.FaizLetter1}></img>,
                    },
                    {
                      description : "A letter from Faiz to Hameed Akhtar",
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="A letter from Faiz to Hameed Akhtar" src={FaizLetter2} id={overlay_styles.FaizLetter2}></img>,
                    },
                    {
                      description : "A letter from Faiz to Hameed Akhtar",
                      title : "",
                      source : "",
                      render : ()=> <img alt="A letter from Faiz to Hameed Akhtar" src={FaizLetter3} id={overlay_styles.FaizLetter3}></img>,
                    },
                    {
                      description : "A letter from Sibt-e-Hasan to Hameed Akhtar (8 August, 1983)",
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="A letter from Sibt-e-Hasan to Hameed Akhtar (August 8, 1983)" src={SHLetter1} id={overlay_styles.SHLetter1}></img>,
                    },
                    {
                      description : <p><i>Roshnai</i>, a book by Sajjad Zaheer presents the history of the Progressive Writers' Movement in India</p>,
                      title : "Sample Title2",
                      source : "Rekhta",
                      render : ()=> <img alt="Roshnai, a book by Sajjad Zaheer" src={Roshnai} id={overlay_styles.Roshnai}></img>,
                    },
                    {
                      description : <p>
                        Sibt-e-Hasan's book <i>Musa se Marx tak</i>. Many of the eminent PWA members were known for their ardent support for socialism in Pakistan
                      </p>,
                      title : "Sample Title2",
                      source : "The Friday Times",
                      render : ()=> <img alt="Sibt-e-Hasan's book 'Musa se Marx' tak" src={MusaMarx} id={overlay_styles.MusaMarx}></img>,
                    }
                    ]
                  }
                />
                <Overlay
                  oId="6"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>Mohammad Hassan Askari (left) and Intizar Hussain (right) were barred from publishing in any of the <i>Anjuman</i> publications</p>,
                      title : "Sample Title",
                      source : "Flickr",
                      render : ()=> <img alt="Mohammad Hassan Askari and Intizar Hussain" src={PWA_Politics} id={overlay_styles.PWA_Politics}></img>,
                    },
                    {
                      description : "Manto, the famous short story writer, was also exluded from the association in 1949",
                      title : "Sample Title",
                      source : "Herald, DAWN",
                      render : ()=> <img alt="Saadat Hasan Manto" src={Manto} id={overlay_styles.Manto}></img>,
                    }
                    ]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "chapter3": {
    name: "Chapter 3: Halqa Arbab-e-Zouq",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div>
                <ChapterTitleMobile
                  inverted
                  image={Chapter3Title}
                  chapter_number="3"
                  chapter_title="Halqa Arbab-e-Zouq"
                  subtitle = "حلقہ ارباب ذوق"
                  id={chTStyles.HAZMobile}
                  images={[{image: HAZLogo1, id: chTStyles.HAZLogo1, shift : 15},
                           {image: HAZLogo2, id: chTStyles.HAZLogo2, shift : -12}]}
                  gradient='linear-gradient(to bottom, rgba(73,58,83,0) 0%,rgba(73,58,83,0.48) 48%,rgba(73,58,83,0.97) 97%,rgba(73,58,83, 1) 100%)'
                />
                <MobileSectionTitle
                  image={ch3Light}
                  title="Overview"
                  chapterNumber="CHAPTER 3: HALQA ARBAB-E-ZOUQ"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>What began as an informal group for writers soon became an important literary collective and organization. Bazm-e-Dastangoyan’s name was changed to Halqa Arbab-e-Zauq in September 1939. Its procedures were formalized in 1940 when the group’s membership and social presence became a concern. Initially, its meetings were held at the residence of its members. In 1944, the group relocated permanently to the YMCA.</p>
                  <p className={mobileStyles.mobilePara}>The Halqa had also received a lot of criticism because it was wrongly perceived as a reaction to the Progressive Writers Movement and due to the literary leanings of some of its members who favoured the notion of art for art’s sake. This is despite the fact  that the Halqa’s annual publication had also promoted writers such as Josh whose poetry was aimed at social revolution. Either way, the Halqa housed and helped many famous as well as aspiring writers, such as Tabish Siddiqui, Ahmed Nadeem Qasmi, Rajinder Singh Bedi, Kanhaiya Lal Kapur and Qayyum Nazar. The organization is functional to this day.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.halqaBook_Mob} className={mobileStyles.shadowImage} src={HalqaBook} alt="Title page of Dr Yunus Javed's book 'Halqa e Arbab-e-Zouq'" onClick={()=> props.setDisplayedOverlay(["1",0])}/>
                    <p className={mobileStyles.mobileImageDesc}>Title page of Dr Yunus Javed's book <i>Halqa e Arbab-e-Zouq</i></p>
                  </div>
                </div>
                <MobileSectionTitle
                  image={ch3Dark}
                  inverted
                  title="Personalities"
                  chapterNumber="CHAPTER 3: HALQA ARBAB-E-ZOUQ"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)} style = {{flexWrap: 'wrap'}}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",4])} id={imageStyles.TaabishMobile} src={Taabish} alt="Taabish Siddiqui" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Taabish Siddiqui</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",5])} id={imageStyles.SherMMobile} src={SherMA} alt="Sher Muhammad Akhtar" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Sher Muhammad Akhtar</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",0])} id={imageStyles.QNMobile} src={QayyumNazar} alt="Qayyum Nazar" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Qayyum Nazar</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",1])} id={imageStyles.YZMobile} src={YusufZafar} alt="Yusuf Zafar" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Yusuf Zafar</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",2])} id={imageStyles.IHMobile} src={IntizarHussain} alt="Intizar Hussain" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Intizar Hussain</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",3])} id={imageStyles.MJMobile} src={Miraji} alt="Miraji" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Miraji</p>
                  </div>
                </div>

                <MobileSectionTitle
                  image={ch3Light}
                  title="Notes from Halqa's meetings"
                  chapterNumber="CHAPTER 3: HALQA ARBAB-E-ZOUQ"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward('3')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward('3')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef('3')}
                    xPos={props.xPos['3']}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} id={imageStyles.Ang1Mobile} onClick={()=> props.setDisplayedOverlay(["3",0])} alt="Halqa Arbab-e-Zouq Notes" src={HN1}/>
                        <p className={mobileStyles.mobileImageDesc}>16 Feb 1942</p>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",1])} alt="Halqa Arbab-e-Zouq Notes"  src={HN2}/>
                        <p className={mobileStyles.mobileImageDesc}>16 Feb 1942</p>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",2])} alt="Halqa Arbab-e-Zouq Notes"  src={HN3}/>
                        <p className={mobileStyles.mobileImageDesc}>14 Dec 1948</p>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",3])} alt="Halqa Arbab-e-Zouq Notes"  src={HN4}/>
                        <p className={mobileStyles.mobileImageDesc}>9 May 1950</p>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["3",4])} alt="Halqa Arbab-e-Zouq Notes"  src={HN5}/>
                        <p className={mobileStyles.mobileImageDesc}>16 June 1954</p>
                      </div>
                  </HorizontalScroll>
                </div>


                <NextChapterTitle
                  inverted
                  image={Chapter4Title}
                  title="Miraji"
                  nextChapter="chapter4"
                  prevChapter="chapter2"
                />
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p><i>Halqa Arbab-e-Zouq: Organization, Movement, Ideology</i> - a book on the history and literary activities of the Halqa by Dr. Yunus Javed</p>,
                      title : "Sample Title",
                      source : "Goodreads",
                      render : ()=> <img alt="Title page of Dr Yunus Javed's book 'Halqa e Arbab-e-Zouq'" src={HalqaBook} id = {overlay_styles.HalqaBook}></img>,
                    }]
                  }
                />
                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>
                        His actual name was Khawaja Abdul Qayyum Butt, but he wrote under the pen name Nazar, popularizing him as Qayyum Nazar. He was an eminent member of the Halqa and a poet. He was a professor at Government College Lahore and Punjab University.
                      </p>,
                      title : "",
                      source : "Rekhta",
                      render : ()=> <img alt="Qayyum Nazar" src={QayyumNazar} id = {overlay_styles.QayyumNazar}></img>
                    },
                    {
                      description : <div>
                        Yusuf Zafar was a prominent member of the Halqa Arbab-e-Zauq who joined the group in its early phase and was appointed its Secretary. Zafar was a poet who had also abandoned the <i>ghazal</i> genre for the <i>nazam</i> format. Perhaps due to this change, Zafar had also joined the literary journal <i>Hamayun</i> in 1942, a publication that famously promoted the <i>jadeed nazam</i> (modern poem) . Due to this change, his work is clearly divided between his classical poetics and modern sensibility. Zafar had been one of the initial few members of the Halqa to back Miraji when he expressed the need for constructive, even oppositional, criticism to the works being read out in the meetings of the Halqa.
                        <p className={overlay_styles.source}>Source: Rekhta</p>
                      </div>,
                      title : "",
                      source : "",
                      render : ()=> <img alt="Yusuf Zafar" src={YusufZafar} id = {overlay_styles.YusufZafar}></img>
                    },
                    {
                      description : <div>
                        Intizar Hussain’s time at the Halqa Arbab-e-Zauq led to a lot of contentions. As a literary critic, he was bound to be more critical of the form of the texts being presented at the meetings, which led to his clashes with other members. The charged political environment of the 50s had begun to reflect in the dynamics of the Halqa as well where differing 24th opinions had begun to split the group in 1954. However, the real trouble began for Hussain on 13 June 1954 when he criticized Amjad Altaf’s story “Nirvan” for its dialogical narrative style which he felt was incompatible with a psychological narrative. To this, Qayyum Nazar retorted that one cannot dictate the narrative style to a writer. Nazar also criticized Hussain’s own work for only having narrative techniques and no meat. Using this interaction as an excuse, Hussain was dismissed from the Halqa according to this notice from 16 June 1954.
                        <p className={overlay_styles.source}>Source: Ata-ul-Haq Qasmi's collection</p>
                      </div>,
                      title : "",
                      source : "",
                      render : ()=>
                        <div id = {overlay_styles.HN5}>
                          <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN5} vbx='800' vby='655' r='11'
                            hotspots={[
                              {x: '660', y: '210', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``}
                            ]}>
                          </HotspotImage>
                        </div>
                    },
                    {
                      description : <p>
                        Miraji was an important literary figure and poet, recognized mostly for his eccentric lifestyle as well as poetry. He had a formative role to play in the development of the Halqa Arbab-e-Zauq. Miraji was inducted into the Halqa on 25 August 1940. He placed a lot of emphasis on the appreciation of art by ensuring that writers were not just praised (in the form of chants of <i>wah wah</i>) but also provided with constructive criticism and debate regarding their work. Because this was an uncommon practice at the time, his efforts led to a split in the Halqa with one group favoring uncritical appreciation of poetry and the other leaning towards a more critical reception. Miraji was also an avid defender of art for art’s sake. He argued that those who criticize classical Urdu literature for being out of touch with the realities of life are misguided because all emotions and expression are essentially rooted in the human experience. He also believed that art for life’s sake cannot exist if one does not first realise the necessity of art on its own. Miraji also took up a managerial role in the Halqa. Having first lost to Muhammad Akhtar as President of the Halqa, he later went on to take the same role, presiding over the debates as well as the publications.
                      </p>,
                      title : "",
                      source : "",
                      render : ()=> <img alt="Miraji" src={Miraji} style={{width: '50%', marginLeft: '25%'}}></img>
                    },
                    {
                      description : <p>
                        Siddiqui was a renowned poet and one of the earliest members of the Halqa Arbab-e-Zouq who had hosted its initial meetings at his residence in Javed Manzil, Rahim Road in Misri Shah before the Halqa had any fixed, official location. The photo shows Siddiqui’s poem published in the newspaper, <i>Inqilab</i>
                      </p>,
                      title : "",
                      source : "",
                      render : ()=> <img alt="Taabish Siddiqui" src={Taabish} id = {overlay_styles.Taabish}></img>
                    },
                    {
                      description : <div>
                        <p>
                        Akhtar was one of the leading figures in the creation of the Halqa Arbab-e-Zouq and an affiliate of the <i>Anjuman Himayat-e-Islam</i>. In fact, the Halqa was his and Naseer Ahmed Jamai’s brainchild. The two had realized the need for a place where writers could merely sit and talk. Hence, they began the Halqa without an actual literary or political agenda in mind. The Halqa was initially named the Bazm-e-Dastangoya and its first session was held at Akhtar's house called the Lakshmi Mansion on McLeod Road. At the same time, Akhtar was also associated with the <i>Anjuman Himayat-e-Islam</i>.
                        </p>
                        <p>
                          The picture shows title page of Akhtar's book, <i>'Lo ek Qissa Suno'</i>
                        </p>
                        <p className={overlay_styles.source}>Source: Rekhta</p>
                      </div>,
                      title : "",
                      source : "",
                      render : ()=> <img alt="Sher Muhammad Akhtar" src={SherMA} id = {overlay_styles.SherMA}></img>
                    }]
                  }
                  />
                  <Overlay
                    oId="3"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description :
                        <div>
                          <p>
                            Meeting notes from 16 February 1942 mention Qayyum Nazar, Miraji, Yusuf Zafar and Sher Muhammad Akhtar.
                          </p>
                          <p>
                            <i>Behtereen Nazmein</i>: The Halqa had begun a tradition of publishing a selection of the best poems that had been published the previous year. This tradition began in 1942 and the archive shows that the first selection committee comprised of Muhammad Akhtar, Qayyum Nazar and Miraji who were entrusted with selecting the best publications of the previous year from nation-wide literary magazines. The collection consisted of poems by authors such as Ahmed Nadeem Qasmi, Faiz Ahmed Faiz, Josh Maleehabadi, Nazar and N. M. Rashid.
                          </p>
                          <p className={overlay_styles.source}>Source: Ata-ul-Haq Qasmi's collection</p>
                        </div>,
                        title : "",
                        source : "",
                        render : ()=>
                          <div id = {overlay_styles.HN1}>
                            <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN1} vbx='800' vby='1040' r='11'
                              hotspots={[
                                {x: '450', y: '280', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                                {x: '675', y: '325', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                                {x: '690', y: '435', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``}
                              ]}>
                            </HotspotImage>
                          </div>
                      },
                      {
                        description : <p>
                          Miraji’s original signature (proceedings of Halqa Arbab-e-Zauq, 16 February 1942)
                        </p>,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : () =>
                          <div id = {overlay_styles.HN2}>
                            <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN2} vbx='800' vby='636' r='11'
                              hotspots={[
                                {x: '625', y: '335', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                                {x: '650', y: '150', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true},
                                {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                              ]}>
                            </HotspotImage>
                          </div>
                      },
                      {
                        description : <div>
                          The meeting’s location has been recorded as ‘India Tea House’ which was the predecessor to the Pak Tea House. Before the Partition, the India Coffee House and the India Tea House were “the two most popular meeting places of the intellectual and literary coteries”. However, this meeting, which was recorded in 1948 still uses the name India Tea House, showing that the switch was more gradual since the old name resonated with people.
                          <p className={overlay_styles.source}>Source: Ata-ul-Haq Qasmi's collection</p>
                        </div>,
                        title : "",
                        source : "",
                        render : () =>
                        <div id = {overlay_styles.HN3}>
                          <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN3} vbx='800' vby='988' r='11'
                            hotspots={[
                              {x: '660', y: '35', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '650', y: '220', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                            ]}>
                          </HotspotImage>
                        </div>
                      },
                      {
                        description :
                        <div>
                          <p>
                            After the Partition, the Halqa turned its attention towards the role of literature in the newly created state. The Halqa devoted a lot of time pondering over the promotion and development of Urdu, the new national language. With this consideration, the Halqa aimed to set up its branches in other towns and cities, of which Karachi was one. The export of literary material from Lahore to Karachi served to maintain the centrality of Lahore in the literary milieu of Pakistan.
                          </p>
                          <p>
                            <i>Urdu ka mustaqbil</i> (The future of Urdu): After 1947, the literary focus of the Halqa Arbab-e-Zouq was towards the promotion of a new national literature. This archive quotes an instruction for the Halqa’s branch in Peshawar for their next publication to focus on the “future”.
                          </p>
                          <p className={overlay_styles.source}>Source: Ata-ul-Haq Qasmi's collection</p>
                        </div>
                        ,
                        title : "",
                        source : "",
                        render : ()=>
                        <div id = {overlay_styles.HN4}>
                          <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN4} vbx='800' vby='988' r='11'
                            hotspots={[
                              {x: '700', y: '810', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '470', y: '39', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                            ]}>
                          </HotspotImage>
                        </div>
                      },
                      {
                        description : <p>
                          A notice dismissing Intizar Hussain from the Halqa (Proceedings of the Halqa Arbab-e-Zouq, 16 June 1954).
                        </p>,
                        title : "",
                        source : "Ata-ul-Haq Qasmi's collection",
                        render : () =>
                        <div id = {overlay_styles.HN5}>
                          <HotspotImage pulsating width="100%" marginBottom="0px" imageSrc={HN5} vbx='800' vby='932' r='11'
                            hotspots={[
                              {x: '675', y: '350', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: '', text: ``},
                              {x: '650', y: '150', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true},
                              {x: '665', y: '260', fill: '#bdbdbd', stroke: '#606060', opacity: '0', name: '', text: ``, invisible: true}
                            ]}>
                          </HotspotImage>
                        </div>
                      }]
                    }
                    />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "chapter4": {
    name: "Chapter 4: Miraji",
    component : (
      <MobileSlide>
      {
          (props)=>{
            return (
              <div>
                <ChapterTitleMobile
                  inverted
                  image={Chapter4Title}
                  chapter_number="4"
                  chapter_title="Miraji"
                  subtitle = "میراجی"
                  id={chTStyles.MirajiMobile}
                  images={[{image: MeerajiTitle, id: chTStyles.MeerajiTitle}]}
                  gradient='linear-gradient(to bottom, rgba(82,22,22,0) 0%,rgba(92,17,17,0.48) 48%,rgba(101,11,11,0.97) 97%,rgba(110, 2, 2, 1) 100%)'
                />
                <MobileSectionTitle
                  image={ch4Dark}
                  inverted
                  title="Miraji’s Rise from Mozang, Lahore"
                  chapterNumber="CHAPTER 4: MIRAJI"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>Miraji was one of the central literary figures leading and influencing the Halqa Arbab-e-Zauq. Born in Mozang, Miraji was a larger than life and enigmatic figure surrounded by mystery. His life in Mozang’s “tightly scripted lanes” seemed to impact his image and persona; he appeared as a wild, and even an insane vagabond, growing up in colonial Lahore’s narrow streets, dirt and disease. A “walking, wandering corpse”. Miraji thus stood out in the crowded and animated cityscape of Mozang - aloof, struggling with and contemplating on notions of love, sexuality, desire, intimacy and himself, within a poetic and yet ugly world. Yet, Miraji’s persona is remembered to also be generous, respectful, and grateful - with a deep understanding of sharing literary work, appreciating aesthetic, analyzing and critiquing literature to push its boundaries beyond the conventional, and a journey of self-discovery.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img id={imageStyles.MirajiPortMobile} src={MeerajiPort} alt="Miraji" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}>Miraji</p>
                  </div>
                </div>
                <MobileSectionTitle
                  image={ch4Light}
                  title="Miraji shaping Lahore’s Literary Culture"
                  chapterNumber="CHAPTER 4: MIRAJI"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>
                    Miraji’s life in Lahore built the foundations of his poetic worldview and literary style and position. It is here that he discovered his literary passion while attending Mozang High School, writing with the pen name of <i>Sahar</i>. His brother introduced him to aspiring literary figures and Miraji began to learn how to interact and make his place in literary circles. Published at an early age, Miraji quietly made his mark within Lahore’s literary tradition, sharing his work and presence in various literary centers and coffee houses of the city. During his journey of becoming the nucleus of literary activity in Lahore, he became the Poetry Editor at <i>Adabi Dunya</i> (Literary World), the Lahore magazine of letters, gaining a profound platform for the publishing of his poems, essays and critiques. With his writing and voice becoming significant for Lahore’s literary culture, the wild, vagabond, “shipwrecked” Miraji eventually contributed to the Halqa in ways that changed Urdu literary experience. Thus, the city made the poet who then influenced the city and its culture in turn.
                  </p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward('1')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward('1')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef('1')}
                    xPos={props.xPos['1']}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} id={imageStyles.Ang1Mobile} onClick={()=> props.setDisplayedOverlay(["1",0])} alt="Miraji - Is Nazm mein" src={MeerajiNazm}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["1",1])} alt="Miraji ki nazmein"  src={MeerajiNazmein}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["1",2])} alt="Chiragh Hasan Hasrat and Miraji"  src={Chirag_Miraji}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                          <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1", 3]} linkMessage="" linkSource="" image={MeerajiVideo} imageStyle={{width: '85%', alignSelf: 'center'}}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33)}>
                        <img className={classNames(mobileStyles.shadowImage, imageStyles.full_gallery)} onClick={()=> props.setDisplayedOverlay(["1",4])} alt="Miraji's Death News"  src={MirajiDeath}/>
                      </div>
                  </HorizontalScroll>
                </div>

                <MobileSectionTitle
                  image={ch4Dark}
                  inverted
                  title="Miraji’s Mind: Love and the City"
                  chapterNumber="CHAPTER 4: MIRAJI"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>
                    Various locations and experiences in Lahore create fragmented memories that built Miraji in the 1920’s and 30’s - his thoughts, feelings, poetic expressions and even his name and identity. Here he met Bashir Chand, his first love, to whom he wrote letters and contemplated on the meaning of desire, love and what they meant for him and the figure he was supposed to be. However, the most profound, permanent and ever-lasting experience was that of stumbling upon and falling in love with Mira Sen, the daughter of a known Professor in Lahore. Mira Sen’s love made F.C College (where she studied), YMCA (Young Men’s Christian Association- where he tried to talk to her), Kinnaird College (where he used to gather with his company to observe Mira with her friends) and Lek Road (where she lived) life changing locations for Miraji. Although Mira never spoke to him, the poet gave himself the name Miraji, attaching himself to his unrequited love and desire, and bringing those themes to the forefront in his writing changing the entire course of the city’s literary experience.
                  </p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",0])} id={imageStyles.MirajiGeetMob} src={MeerajiGeet} alt="'Geet hi Geet' by Miraji" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}></p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",1])} id={imageStyles.MirajiPoemMob} src={MeerajiPoem} alt="'Jawani ke ghao' by Miraji" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}></p>
                  </div>
                </div>

                <MobileSectionTitle
                  image={ch4Light}
                  title="Miraji, the Halqa and Demonic Desire and Femininity"
                  chapterNumber="CHAPTER 4: MIRAJI"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.increased_padded_top)}>
                  <p className={mobileStyles.mobilePara}>
                    Miraji brought together and tangled themes of differing kinds of desire, love, sexuality, nationalism, modernity and debates on masculinity and femininity. He lived while opposing colonial and patriarchal contexts of nationalism represented by masculinity. Seen as self- absorbed and possibly “demonic”, Miraji was associated with a language and imagery reserved for femininity - a senseless experience of hysteria, nymphomania, eroticism and sentimentality. He was not the “stoic” or “chivalrous” male nationalist - his voice addressed himself as just “I” and yet spoke in harmony with differing nationalist voices from the right and the left, both. Miraji thus lived in fluidity, perhaps even became that fluidity - of thought, emotion, social position and personal discovery. Thus, when Miraji entered the Halqa in 1940, he brought his style of close literary reading, rigorous analysis and appreciation alongside critique, to widen the literary scope and experience of the city and its literary figures. With the emergence of the Progressive Writers’ Association (Urdu Chapter), Miraji was systematically excluded and isolated from the Pan-Indian literary experience for his unconventional writings, persona and breaches of the PWA literary canon.
                  </p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom, mobileStyles.increased_padded_top)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["3",0])} id={imageStyles.MirajiGeetaMob} src={MeerajiGeeta} alt="Geeta Patel's book on Miraji" className={mobileStyles.shadowImage}/>
                    <p className={mobileStyles.mobileImageDesc}></p>
                  </div>
                </div>

                <NextChapterTitle
                  inverted
                  image={ProjectCreditsBack}
                  title="Credits"
                  nextChapter="credits"
                  prevChapter="chapter3"
                />
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>
                        Title cover of Miraji’s first edition of <i>Iss Nazam Mein</i> published from Delhi. Despite the “madness”, “obscenity” and “abnormality”, Miraji’s writings, voice and mind gradually made a significant place for itself in Lahore’s literary circles and experience, setting the foundations for the Halqa Arbab e Zauq in Lahore.
                      </p>,
                      title : "",
                      source : "DAWN",
                      render : ()=> <img alt="Miraji - Is Nazm mein" src={MeerajiNazm} id={overlay_styles.MeerajiNazm}></img>,
                    },
                    {
                      description : "Miraji's Poems",
                      title : "",
                      source : "DAWN",
                      render : ()=> <img alt="Miraji ki nazmein" src={MeerajiNazmein} id={overlay_styles.MeerajiNazmein}></img>,
                    },
                    {
                      description : "Miraji photographed with Chiragh Hasan Hasrat",
                      title : "",
                      source : "Flickr",
                      render : ()=> <img alt="Chiragh Hasan Hasrat and Miraji" src={Chirag_Miraji} id={overlay_styles.Chirag_Miraji}></img>,
                    },
                    {
                      description : "Hussam Badi reads 'Portrait of Miraji' - Aijaz Ahmad's impression of Miraji",
                      title : "",
                      source : "Zer Zabar Pesh",
                      render : ()=> <VideoFrame link="https://www.youtube.com/embed/BqdnyxrGVdo"/>,
                    },
                    {
                      description : <p>
                        A newspaper clipping of Miraji’s early death at age 37, which brought an end to a literary era where his writing, persona and unconventionality challenged notions of normality within literary circles. Miraji was built by Lahore - fragments of childhood memories and places shaped him as he came to be known as the abnormal, insane and yet a gifted literary figure.
                      </p>,
                      title : "",
                      source : "Flickr",
                      render : ()=> <img alt="Miraji Death News" src={MirajiDeath} id={overlay_styles.MirajiDeath}></img>,
                    }
                    ]
                  }
                />
                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>Miraji's book <i>Geet hi Geet</i></p>,
                      title : "",
                      source : "DAWN",
                      render : ()=> <img alt="'Geet hi Geet' by Miraji" src={MeerajiGeet} id={overlay_styles.MeerajiGeet}></img>,
                    },
                    {
                      description : <p>Miraji's Poem, <i>Jawani ke ghao</i></p>,
                      title : "",
                      source : "DAWN",
                      render : ()=> <img alt="'Jawani ke ghao' by Miraji" src={MeerajiPoem} id={overlay_styles.MeerajiPoem}></img>,
                    }

                    ]
                  }
                />
                <Overlay
                  oId="3"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p><i>Lyrical Movements, Historical Hauntings - On Gender, Colonialism, and Desire in Miraji’s Urdu Poetry</i> by Geeta Patel</p>,
                      title : "",
                      source : "Stanford University Press",
                      render : ()=> <img alt="Geeta Patel's book on Miraji" src={MeerajiGeeta} id={overlay_styles.MeerajiGeeta}></img>,
                    }]
                  }
                />
              </div>
            )
        }
      }
      </MobileSlide>
    ),
    menuInverted: true
  },
  "credits" : {
      name: "Credits",
      component : (
        <MobileSlide>
          {
            (props)=>{
              return (
                <ProjectCreditsMobile
                  image={ProjectCreditsBack}
                  disclaimer=<span>These projects are based on research conducted by students for the course <i>Walking in the City: Mapping Everyday Life in Lahore.</i></span>
                  projectName="Lahore's Literary Landscape "
                  studentNames="Amen Imran, Fatima Afzal, Hassan Aziz, Mahnoor Kazmi, Rana Muhammad Haris Khan and Zohra Aslam"
                  supervisor={{name: 'Dr Ali Usman Qasmi', desig: 'Associate Professor (History), Department of Humanities and Social Sciences, LUMS'}}
                />
              )
            }
          }
        </MobileSlide>
      ),
      menuInverted : true,
    }
}

const mobileImageArr = [];

export {
    slideMap,
    slideOrder,
    imageArr,
    chapterArr,
    mobileSlideMap,
    mobileImageArr
};
